import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import Swal from "sweetalert2";
import { configuration } from "../appConfig";
import moment from "moment";
import Lightbox from "react-image-lightbox";
import dashboardErrorImg from "../../src/assets/img/brand/dashboard-error-logo.png"
import { Spinner } from "reactstrap";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export class PreDamage13SVG extends Component {
  constructor(props) {
    super(props);
    this.PreDamage = React.createRef(null);
    this.state = {
      vin: "",
      lang: "",
      words: {},
      loading: false,
      imageSrc: "",
      captureImageName: "",
      extraImageNameArr: [],
      extraImageNameArr_1: [],
      isLightBoxOpen : false,
      clickedPartName : "",
    };
  }

  componentDidMount = () => {
    this.getLang();
  };
  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };

//   getPreDamageImages = () => {
//     let partnerId = localStorage.getItem("partnerId");
//     const vin = localStorage.getItem("selectedFile");
//     const url = `${configuration.getExtraImages}?partnerId=${partnerId}&vin=${vin}&partName=yes`;
//     axios
//       .get(url)
//       .then((res) => {
//         let extraImageNameArr_1 = [];
//         if (res && res.data.extraNewImages) {
//           for (const key in res.data.extraNewImages) {
//             if (Object.hasOwnProperty.call(res.data.extraNewImages, key)) {
//               const element = res.data.extraNewImages[key];
//               const partName =
//                 element.name &&
//                 element.name.split("/")[element.name.split("/").length - 1];
//               extraImageNameArr_1.push(partName);
//             }
//           }
//           this.setState({
//             extraImageNameArr_1,
//           });
//         }
//       })
//       .catch((err) => {
//       });
//   };

  getBase644 = async (file) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        reject(error);
      };
    });
  };

  capture = async (e) => {
    // if (e.target.files.length > 0) {
    //   this.setState(
    //     {
    //       imageSrc: e.target.files[0],
    //     },
    //     () => {
    //       this.props.uploadExtraImagesNew(this.state.imageSrc, this.state.captureImageName, this);
    //     }
    //   );
    // }
    const { files } = e.target;
    const base64 = await this.getBase644(files[0]);
    this.setState(
      {
        imageSrc: base64,
      },
      () => {
        this.props.uploadExtraImagesNew(
          this.state.imageSrc,
          this.state.captureImageName,
          this
        );
      }
    );
  };

  userClick = (part) => {
    this.setState({
      captureImageName: part,
      imageSrc: "",
    });
    if (!this.fillColor(part)) {
      if (this.props.authorized) {
        Toast.fire({
          type: "error",
          title: this.lang("ThisVINisAuthorized"),
        });
        return
      }
      this.PreDamage.click();
    } else{
      this.openImage(part)
    }
  };

  openImage =(clickedName)=>{
    const {extraNewImages} = this.props
    console.log(clickedName);
    const findName = extraNewImages && extraNewImages.length > 0 && extraNewImages.find((partName)=>{
      return partName.part == clickedName
    })
    this.setState({clickedPartName : findName.name,isLightBoxOpen : !this.state.isLightBoxOpen, clickedPartObj : findName})
  }

  fillColor = (part) => {
    const { extraImageNameArr_1 } = this.props
    let partimages = extraImageNameArr_1.filter(
      (item) => item.includes(part) && item.split(".")[0].length === part.length
    );
    if (partimages[0]) {
      return "#EF3D3C";
    }
  };
  addClassName = (part)=>{
    const { extraImageNameArr_1 } = this.props
    let partimages = extraImageNameArr_1.filter(
      (item) => item.includes(part) && item.split(".")[0].length === part.length
    );
    if (partimages[0]) {
     
      return "svg-parts-fill";
    } else {
      return null
    }
  }
  handleRetake = ()=>{
    this.PreDamage.click();
  }
  handlerotate = ()=>{
    const {clickedPartObj} = this.state;
    const splitName = clickedPartObj.name.split("/")[clickedPartObj.name.split("/").length -1]
    this.props.handlerotate(splitName)
  }
  handleDelete =async()=>{
    const {clickedPartObj} = this.state;
    await this.props.handleDelete(clickedPartObj)
    await this.setState({isLightBoxOpen: false})
  }

  render() {
    const {isLightBoxOpen,clickedPartName} = this.state
    const {isRotateLoading, isDeleteLoading} = this.props
    let toolbarButtons = [];
    toolbarButtons = [
      <>
        <div className="photo_app_image_lightbox_wrapper">
          <button
            onClick={() => this.setState({ isLightBoxOpen: !isLightBoxOpen })}
          >
            <i className="fa fa-check"></i>

          </button>
          <button
          disabled={this.props.authorized}
          onClick={() => this.handleRetake()}>
            <i className="fa fa-camera"></i>
          </button>
          {/* <button onClick={() => this.toggleEdit()}>
            {isEditLoading ? <Spinner /> : <i className="fa fa-pencil"></i>}
          </button> */}
          <button
          disabled={this.props.authorized}
          onClick={() => this.handlerotate()}>
            {isRotateLoading ? <Spinner style={{ height: '1rem', width: '1rem' }} /> : <i className="fa fa-repeat"></i>}
            {/* <i className="fa fa-repeat"></i> */}
          </button>
          <button
          disabled={this.props.authorized}
          onClick={() => this.handleDelete()}>
            {isDeleteLoading ? <Spinner style={{ height: '1rem', width: '1rem' }} /> : <i className="fa fa-trash"></i>}
          </button>
        </div>
      </>,
    ];
    return (
      <>
        <input
          type="file"
          name="image"
          id="file"
          // ref="PreDamage"
          ref={(input) => (this.PreDamage = input)}
          accept="image/*"
          capture="environment"
          style={{ display: "none" }}
          onChange={(e) => this.capture(e)}
        />

<svg
                            version="1.1"
                            id="Layer_1"
                            xmlnsx="&ns_extend;"
                            xmlnsi="&ns_ai;"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 550 1080"
                            style={{ enableBackground: "new 0 0 550 1080" }}
                            // style={{ enableBackground: "new 0 0 373.5 928.5" }}
                            xmlSpace="preserve"
                          >
                            <style type="text/css">
                              {`.st0{fill:#EF3E3D;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}
	.st1{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}
	.st2{fill:#EF3E3D;stroke:#000000;stroke-miterlimit:10;}
	.st3{fill:#FFFFFF;}`}
                            </style>

                            <g>
                              <path
                                class="st0"
                                d="M250.5,540c-0.4,0-0.7,0-1,0l0,0H250.5z"
                              />
                              <path
                                style={{ fill: this.fillColor("svg_LeftFrontDoor") }}
                                onClick={() => this.userClick("svg_LeftFrontDoor")}
                                class="st1"
                                d="M165.7,493.4c0,4.3-0.3,8.6-0.3,12.7c0,25.8,0,51.6,0,77.4c0,2.1-0.2,4.6-2,5.7c-1,0.6-2.3,0.6-3.5,0.6
		c-7.9,0-15.8-0.4-23.7-0.4c-10.7,0-21.3,0.2-32-0.1c-1.3-36.3-1.6-72.5-1.2-108.8c0.2-16.5,0.5-32.9,0.5-49.5
		c0.3-10.4,0-20.9-0.1-31.3c3,2.6,5.8,5.5,8.3,8.5c10.6,12.7,18.8,27.5,29,40.5c4.2,5.5,8.7,10.8,12.9,16.2
		c4,5.3,8.8,10.9,10.6,17.3C165.4,485.8,165.7,489.6,165.7,493.4z"
                              />
                              <path
                                class="st1"
                                d="M250,95.1c62,1,124.8,4.6,184.3,22.1c2.2,0.6,4.5,1.3,6.2,3c2.4,2.2,3.1,5.7,3.6,9.1c0.1,0.7,0.2,1.4-0.2,2.1
		c-1,1.6-3.5,0.1-4.6-1.5c2.2,10.1,3.6,20.6,3.9,31c1.3,0.1,2.6,0.2,3.7,0.8c1.5,1,1.9,3.2,0.2,4.2c-0.6,0.4-1.4,0.4-2.2,0.5
		c-17.5,1.9-35.1,2.3-52.6,4c-19.1,1.9-38.1,3.2-57.4,1.9c-5.1-0.4-10.4-1.2-15.5-1.2c-19.3-1.4-38.5-2.8-57.8-3.1
		c-2.5-0.1-6.9-0.1-11.5-0.3c-4.6,0.2-9.1,0.2-11.5,0.3c-19.3,0.4-38.6,1.7-57.8,3.1c-5.1,0-10.4,0.7-15.5,1.2
		c-19.2,1.4-38.2,0-57.4-1.9c-17.5-1.7-35.1-2.2-52.6-4c-0.7-0.1-1.5-0.2-2.2-0.5c-1.8-0.9-1.3-3.2,0.2-4.2c1.1-0.7,2.4-0.7,3.7-0.8
		c0.4-10.4,1.6-20.7,3.9-31c-1.1,1.6-3.6,3.2-4.6,1.5c-0.4-0.6-0.3-1.3-0.2-2.1c0.5-3.2,1.2-6.7,3.6-9.1c1.7-1.5,3.9-2.2,6.2-3
		C125.2,99.7,188,96,250,95.1z"
                              />
                              <path
                                class="st1"
                                d="M129.8,111.5L129.8,111.5c0.7-0.2,8.6-2.8,8.5-1.2c-0.1,3-0.4,5.9-0.7,8.9c-0.3,4.6-0.4,9.2-1,13.6
		c-0.3,2.4-0.7,4.8-0.8,7.3c-0.1,2.9-0.1,6-1.3,8.6c-1.7,3.4-5.4,3-8.7,3c-4.1,0-8.3,0.4-12.3,1.3c-3.9,0.8-7.8,2-11.8,2.2
		c-3.2,0.3-6.5,0.7-9.6,1c-1,0.1-2.1,0.2-3.1,0.3c-5.1,0.5-10.1,1.2-15.2,2.1c-2.3,0.4-4.7,1.1-7,1.1c-2.5,0-5-0.4-7.5-0.7
		c-0.9-0.2,0.8-10.9,0.9-11.8c0.5-6.2,1.2-12.5,2.6-18.5c0.5-2.2,1.9-3.1,4.2-3.5c4.9-0.8,9.8-2.2,14.6-3.2
		c5.2-1.1,10.3-2.2,15.4-3.5c7.3-1.8,14.4-3.6,21.7-4.7C122.5,113.3,126.2,112.6,129.8,111.5z"
                              />
                              <path class="st1" d="M79,156.3" />
                              <path
                                class="st1"
                                d="M79,133.2c-3.1,1.1-5.5,4.1-5.7,7.4c-0.5,6.1,5.7,10.9,11.3,8.4C93.5,145.1,88.3,130.1,79,133.2z"
                              />
                              <path
                                class="st1"
                                d="M78.2,130.1c-4.4,1.4-7.6,5.7-8,10.2c-0.7,8.5,7.8,15.1,15.7,11.7C98.3,146.6,90.9,125.8,78.2,130.1z"
                              />
                              <path
                                class="st1"
                                d="M111,124.7c-3.9,1.3-6.9,5.2-7.3,9.3c-0.6,7.8,7.1,13.8,14.4,10.7C129.4,139.7,122.6,120.8,111,124.7z"
                              />
                              <path
                                class="st1"
                                d="M109.9,120.8c-5.6,1.9-9.6,7.2-10.1,12.9c-0.9,10.8,9.9,19.1,19.9,14.8C135.4,141.7,126,115.3,109.9,120.8z"
                              />
                              <path
                                class="st1"
                                d="M72.2,288.8c-0.8-8-3.3-15.9-7.4-22.8c-8.1-14.2-21.9-24.4-38-27.6c-5.2-1.1-9.7-2.6-15-1.7
		c0,25.8,0,51.5-0.1,77.3c0,5.3-0.1,10.6-0.2,15.9c-0.1,5.1,0,10.3-0.4,15.4c-0.1,2.2-0.5,5.5,1.3,7.2c1.7,1.6,4.2,1.4,6.4,1.1
		c2.5-0.4,5.1-1.2,7.6-1.8c5.6-1.3,11.2-3.1,16.3-5.7c8.9-4.6,16.2-12.3,21.2-20.8c5-8.4,8-18,8.4-27.7c0-0.3,0-0.4,0-0.7
		c0.1-1.9,0-3.8-0.1-5.7C72.4,290.2,72.3,289.5,72.2,288.8z"
                              />
                              <path
                                class="st1"
                                d="M205.2,388.2c-8,7.1-18.5,11.3-29.3,10.8c-5.1-0.3-10.1-2-14.8-3.9c-3-1.2-5.8-2.4-8.4-4.2
		c-1.4-1.1-5.7-4-4.5-6.3c0.8-1.5,2.9-1.9,4.4-2.3c2.1-0.6,4.2-1.3,6.3-1.8c6-1.5,12.2-2.3,18.3-3.5c6.3-1.3,12.6-2.3,18.9-3.3
		c4.8-0.7,9.4-1.1,14.2-1.7c1.9-0.2,4.3,0,4.8,2.2c0.5,2.3-1.7,4.9-3.1,6.6c-1.6,2-3.3,3.9-5.1,5.8
		C206.4,387.2,205.8,387.7,205.2,388.2z"
                              />
                              <path class="st1" d="M150.8,181.7" />
                              <path class="st1" d="M144.4,195.8" />
                              <path
                                class="st1"
                                d="M378.3,373.7c-1.3,3.5-2.7,6.9-4,10.3c-0.5,1.3-1.2,2.7-2.5,3c-0.9,0.2-1.9-0.2-2.7-0.6
		c-6.2-3-12.3-5.7-18.8-7.7c-23.6-7.5-48.1-10.5-72.8-11.1c-8.9-0.2-17.8-0.2-26.7-0.2h-0.9c-8.9,0-17.8,0-26.7,0.2
		c-24.7,0.6-49.2,3.7-72.8,11.1c-6.6,2.1-12.7,4.8-18.8,7.7c-0.8,0.4-1.8,0.8-2.7,0.6c-1.3-0.3-2-1.7-2.5-3c-1.3-3.4-2.7-6.9-4-10.3
		c-0.5-1.3-0.7-2.6,0.8-3.3c5.4-2.8,12.3-3.8,18.1-5.3c5.1-1.3,10.3-2.6,15.5-3.6c8.3-1.6,16.6-2.4,25-3.7c10.1-1.5,20.3-2.5,30.5-3
		c5.7-0.3,11.3,0.2,16.9,0c6.9-0.3,13.8-0.5,20.8-0.7h0.8c7,0.2,13.9,0.4,20.7,0.7c5.7,0.3,11.3-0.3,16.9,0
		c10.3,0.4,20.4,1.3,30.5,3c8.3,1.3,16.7,2.1,25,3.7c5.2,1,10.3,2.3,15.5,3.6c5.8,1.4,12.7,2.4,18.1,5.3
		C379,371,378.8,372.4,378.3,373.7z"
                              />
                              <path
                                class="st1"
                                d="M277.2,368.9c-1.7-0.1-3.5-0.1-5.2-0.2c-13.4-0.4-26.7-0.1-40.2-0.3c-2.9,0-5.7-0.1-8.6-0.1
		c-0.2,0-0.4,0-0.5,0.1c-0.2,0.1-0.3,0.3-0.3,0.4c-4.2,10.1-10.6,18.9-19.7,25.1c-2.1,1.4-4.3,2.7-6.6,3.8
		c-14.7,6.9-33.7,5.7-46.2-5.2c-3-2.6-5.5-7.6-10.1-7.5c-1.5,0.1-3.1,0.7-4.4,1.3c-3.2,1.6-6.6,4-6.6,8.2
		c-0.1,5.7,5.2,12.7,7.9,17.7c3.2,6,6.7,11.8,10.3,17.7c7.1,11.5,14.6,22.7,22.3,33.8c0.5,0.8,1.2,1.7,2.2,2.1
		c0.7,0.3,1.4,0.2,2.2,0.1c3.9-0.4,7.5-1.5,11-2.7c2.8-0.9,5.7-1.4,8.6-1.9c6.2-1,12.3-2.2,18.6-3.1c17.4-2.3,35-3.1,52.5-2.2
		c8.8,0.4,17.5,1.3,26.2,2.5c8.2,1.2,16.9,2.2,24.7,4.7c3.3,1.1,6,2.1,9.4,2.4c1.3,0.1,2.9,0.6,4.1,0.1c2.5-1,4.4-5.7,5.9-7.9
		c2.2-3.1,4.4-6.4,6.6-9.6c4.3-6.5,8.4-12.9,12.4-19.6c3.4-5.7,6.7-11.5,10-17.4c2.6-4.8,7.6-11.2,7.5-16.9
		c-0.1-3.8-2.3-6.7-5.6-8.5c-2.2-1.3-4.8-1.8-7.1-2.7c-2.7-1-5.3-2-8-2.9c-12.6-4.3-25.3-7.4-38.4-9.2
		C300.5,369.8,288.9,369.2,277.2,368.9z"
                              />
                              <path
                                class="st1"
                                d="M64.5,593.1c-4.8,0-9.5,0-14.3,0c-3.9,0-13.3-2.1-15.4,2.8c-0.3,0.5-0.3,1.3,0.2,1.6c0.4,0.4,0.8,0.4,1.3,0.5
		c8.9,1.3,17.8,0.9,26.7,0.9c9.8,0.1,19.5,0.1,29.3,0.2c19.5,0.1,39,0.2,58.5,0.3c2.5,0,5,0,7.6,0c1.4,0,2.9,0,4.3-0.4
		c1.3-0.4,3.3-1.4,2.1-3.1c-2.4-3.3-11.1-2.3-14.6-2.4c-6.6-0.2-13.3,0.3-19.9,0C108.3,592.6,86.4,593,64.5,593.1z"
                              />
                              <path
                                style={{ fill: this.fillColor("svg_LeftBackDoor") }}
                                onClick={() => this.userClick("svg_LeftBackDoor")}
                                class="st1"
                                d="M165.8,711.3c0,0.1-0.1,0.2-0.1,0.3c-0.9,3.1-4.2,5.6-6.3,7.9c-2.8,3.2-5.5,6.6-8.1,10
		c-7.5,10-15.1,19.7-22.8,29.4c-3.9,4.9-7.8,9.9-11.8,14.8c-1.9,2.4-3.8,4.8-5.7,7.2c-1.5,1.9-3.1,4.8-5.1,6.1
		c-0.3,0.2-0.4,0.3-0.7,0.3c-0.7,0-1-1-1-1.8c-0.1-7.3,0.1-14.5,0.1-21.8c0-18,0-36.2,0-54.2c0-19.7,0-39.6,0-59.3
		c0-13,0-26.1,0-39.1c0-2.4-1-7.7,1.3-8.7c0.4-0.2,1-0.2,1.5-0.2c15.1-0.3,30.1-1.1,45.1-1.1c3.4,0,6.7,0,10.1,0c0.7,0,1.3,0,2,0.3
		c0.9,0.4,1.4,1.3,1.7,2.3c0.4,2.2-0.3,4.6-0.3,6.8c0,14.3,0,28.5,0,42.8c0,10.5,0,20.9,0,31.4c0,7.3,0.3,14.6,0.3,21.9
		C166.3,708.1,166.2,709.8,165.8,711.3z"
                              />
                              <path
                                class="st1"
                                d="M18.7,420.7c-0.4-10.1-0.8-20.2-1.3-30.3c-0.4-7.9-0.7-15.7-1.1-23.6c-0.2-3,0.2-5.1,3.2-6.1
		c4.4-1.4,11-3.1,15.3-0.5c3.7,2.2,3.3,8.2,3.7,11.8c0.5,5.6,1.2,11,1.7,16.6c0.4,3.1,0.9,7.4-1.8,9.6c-2.8,2.3-4.5,3.1-4.6,7.1
		c-0.2,25-1.3,49.8-1.3,74.8c-0.3,12.7-0.4,25.4-0.4,38.1c-0.1,13.6,0.3,27.3-0.2,40.8c-0.5,17.3,0.9,34.6,0.6,51.9
		c-0.3,25.8,0,51.5,0,77.4c0,11,0,21.9,0,32.8c0,5.5,0,11,0,16.4c0,7.5-1.6,13.9,5.9,18.3c7,4.1,15.1,6,21.7,10.8
		c4.3,3.1,8.1,6.9,11.6,11c9.6,11.1,7.2,17.4,5.5,18.2c-6.4,2.9-10.4-8.5-13.3-12c-3.1-3.8-6.6-7.2-10.5-10.1
		c-7.6-5.7-16.6-9.9-26-11.8c-5.7-1.2-5.2-4.9-5-10c1-38.3,2.2-76.7,2.6-115c0.2-19.5,0.1-39-0.4-58.5c-0.9-38.5-3-77-4.5-115.5
		C19.8,448.7,19.2,434.7,18.7,420.7z"
                              />
                              <path
                                style={{ fill: this.fillColor("svg_LeftBackDoor") }}
                                onClick={() => this.userClick("svg_LeftBackDoor")}
                                class="st1"
                                d="M102.1,625.6c0-7.1,0-14.1,0-21.2c0-0.7,0-1.4-0.4-1.9c-0.5-0.6-1.4-0.6-2.2-0.6c-20.3-0.3-40.6-0.5-60.9-0.8
		c-1,0-2,0-2.7,0.6c-0.9,0.7-0.9,2.1-0.9,3.2c0,38.7-0.2,77.4,0.5,116c0.1,5.6,0.2,11.2,0.2,16.8c0,3.7-1.8,12.9,1.6,15.3
		c3.2,2.2,8.2,3.2,11.8,4.9c7.1,3.3,14,7.9,19.7,13.5c2.9,2.8,5.5,5.7,7.8,9c2.3,3.3,4.3,7.1,8,9.2c4.4,2.5,10.3,1.7,15,0.3
		c0.6-0.2,1.2-0.4,1.7-0.8c2.7-2.3,1.2-9.3,1.1-12.3c-0.4-14.2-0.1-28.5-0.1-42.7C102.1,697.7,102.1,661.7,102.1,625.6z"
                              />
                              <path
                                class="st1"
                                d="M105.2,420c0-0.9-0.1-1.8-0.1-2.8c0-4.4,0-8.8,0.1-13.2c0-0.3,0.1-0.7,0.4-0.7c0.1,0,0.3,0.1,0.4,0.2
		c0.6,0.5,1.1,1.2,1.5,1.9c1.5,2.2,3.1,4.4,4.6,6.6c0.4,0.6,0.9,1.3,1.2,2.1c0.8,2.1-0.4,4.3-1.7,5.9c-0.7,1.1-1.6,2.1-2.5,3.1
		c-0.4,0.4-0.9,1-1.3,1.4c-0.4,0.4-0.9,1.3-1.6,0.7c-0.4-0.3-0.4-0.7-0.5-1.2C105.4,422.7,105.3,421.4,105.2,420z"
                              />
                              <path
                                class="st1"
                                d="M366.2,805.2c-0.9,1.1-2.7,1.7-4.1,2c-34.6,7.8-70,8.7-105.3,8.7c-14,0-27.9-0.3-41.9-0.7
		c-6.6-0.2-13-0.4-19.5-0.8c-6.8-0.4-13.7-1.5-20.6-1.5c-12.5-1.2-25-2.7-37.1-6.2c-1-0.3-2.1-0.6-2.9-1.3
		c-2.2-1.9,1.5-13.4,2.2-13.2c4.7,1.3,9.2,3.2,13.8,4.4c5.3,1.3,10.7,2.2,16.1,2.9c31.2,4.2,62.8,5.5,94.3,5
		c14.5-0.2,29.2-0.9,43.7-2c14.1-1.1,29-1.7,42.7-5.3c2.9-0.7,5.6-2.1,8.3-2.8c2.4-0.6,4.8-1.3,7.3-2.1c1,3,2,5.8,3,8.8
		c0.3,0.9,0.6,1.9,0.4,2.8C366.7,804.4,366.4,804.8,366.2,805.2z"
                              />
                              <path
                                style={{ fill: this.fillColor("svg_LeftBackFender") }}
                                onClick={() => this.userClick("svg_LeftBackFender")}
                                class="st1"
                                d="M169,718.8c-0.4-0.5-1.1-1-1.8-1c-0.5,0-1,0.2-1.5,0.4c-3.9,1.7-7,4.9-9.7,8.3c-4.3,5.2-8.1,10.8-12.4,16
		c-1.8,2.2-3.6,4.5-5.4,6.7c-3.1,3.9-6.3,8-9.3,12c-1.4,1.9-3,3.8-4.4,5.7c-1.4,1.9-2.8,4.5-4.6,6c-2.1,2.7-4.1,5.4-6.2,8.1
		c-1.8,2.3-3.6,5.4-5.9,7.3c-7.4,7-18.9,3.2-26.7,9.2c-3.1,2.4-3.9,6.1-3.5,9.9c0.4,4.2,1.5,8.3,2,12.6c0.4,4.1,0.5,8.2,0.2,12.3
		c-0.6,8.2-2.9,16.2-6.6,23.4c-0.9,1.7-1.9,3.4-2.9,5c-9.1,14.4-23.8,25-40.2,29c-2.2,0.5-4.8,1.2-6.1,3.1
		c-2.4,3.4-0.7,10.8-0.4,14.7c0.8,10.6,2.5,21.1,4.8,31.4c1.3,6.5,4.6,9.6,10.5,12.4c14,6.6,28.6,11.8,43.6,15.9
		c3.9,1.1,8.2,2,11.8,0.3c4.8-2.2,6.9-8.2,11.6-10.8c-0.2-2.8-3.7-3.9-6.5-4.4c-11-1.6-21.8-3.2-32.8-4.8c-1.8-0.3-3.7-0.5-5.1-1.7
		c-1.3-1.1-2.1-2.9-2.7-4.6c-1.5-4.5-2.3-9.2-2.6-14c-0.2-4.2,2.2-5.1,6-4.8c19.5,1.5,38.9,4.6,58.3,6.8c7.8,0.9,14.1,0.1,19.8-5.7
		c4.8-4.9,9.2-10.1,5.8-16.9c-4.1-8.4-7-17.4-8.8-26.7c-3.8-18.8-5.1-37.9-6.6-56.9c-1.2-16.3,2.8-32.6,9.2-47.5
		c6.6-15.1,16.9-27.6,24.5-41.8c1.3-2.3,2.8-4.5,3.9-6.8c1.1-2.2,2.3-5.3,0.9-7.7C169.1,718.9,169.1,718.8,169,718.8z"
                              />
                              <path
                                style={{ fill: this.fillColor("svg_RightBackFender") }}
                                onClick={() => this.userClick("svg_RightBackFender")}
                                class="st1"
                                d="M331.3,719c-1.4,2.3-0.3,5.4,0.9,7.7c1.2,2.3,2.7,4.5,3.9,6.8c7.6,14.4,18,26.7,24.5,41.8
		c6.5,14.9,10.4,31.1,9.2,47.5c-1.3,19-2.8,38.1-6.6,56.9c-1.9,9.2-4.7,18.2-8.8,26.7c-3.3,6.8,1,11.8,5.8,16.9
		c5.7,5.8,12,6.6,19.8,5.7c19.5-2.2,38.8-5.3,58.3-6.8c3.9-0.3,6.2,0.6,6,4.8c-0.2,4.8-1.1,9.5-2.6,14c-0.5,1.7-1.3,3.4-2.7,4.6
		s-3.3,1.4-5.1,1.7c-11,1.6-21.8,3.2-32.8,4.8c-2.8,0.4-6.3,1.5-6.5,4.4c4.7,2.6,6.7,8.5,11.6,10.8c3.7,1.7,7.9,0.7,11.8-0.3
		c15-4,29.6-9.3,43.6-15.9c5.9-2.8,9.2-5.9,10.5-12.4c2.2-10.3,3.9-20.9,4.8-31.4c0.3-3.9,2-11.3-0.4-14.7c-1.3-1.9-3.9-2.5-6.1-3.1
		c-16.4-4-31.2-14.6-40.2-29c-1.1-1.6-2-3.3-2.9-5c-3.8-7.3-6.1-15.3-6.6-23.4c-0.3-4.1-0.2-8.3,0.2-12.3c0.4-4.2,1.4-8.3,2-12.6
		c0.4-3.8-0.4-7.5-3.5-9.9c-7.7-6.1-19.2-2.3-26.7-9.2c-2.4-1.9-4.1-4.9-5.9-7.3c-2.1-2.7-4.1-5.4-6.2-8.1c-1.8-1.5-3.1-4.1-4.6-6
		c-1.4-1.9-3-3.8-4.4-5.7c-3.1-4-6.2-8-9.3-12c-1.8-2.2-3.6-4.5-5.4-6.7c-4.2-5.2-8.1-10.8-12.4-16c-2.7-3.2-5.7-6.5-9.7-8.3
		c-0.4-0.2-1-0.4-1.5-0.4c-0.7,0-1.3,0.4-1.8,1C331.4,718.8,331.4,718.9,331.3,719z"
                              />
                              <path
                                class="st1"
                                d="M71.7,836.3c-0.3,1.3-0.5,2.7-0.9,4c-3.7,14.7-12.1,27.6-25,35.8c-4.8,3.1-10.2,5.5-15.8,7
		c-1.8,0.4-18.2,3-18.2,1.9V767.2c0.1-0.8,13,1.2,14.4,1.4c5.1,1.1,10.1,2.8,14.6,5.2C63.4,785.4,76,811.7,71.7,836.3z"
                              />
                              <path
                                class="st1"
                                d="M403.7,969.7c-0.1,0.1-0.2,0.2-0.4,0.2c-4.2,1.1-8.6,1.3-12.8,2.4c-2.2,0.5-4.3,1-6.5,1.5
		c-25.9,5.5-53,7-79.3,8.5c-26.9,1.5-53.9,1.9-80.8,1.2c-26.9-0.7-53.9-2.5-80.7-5.4c-15.8-1.7-31.4-4.8-46.9-8.4
		c1.4-3.3,4.2-5.8,6.8-8.3c1.8-1.8,3.6-3.7,5.9-4.7c2.8-1.2,5.9-0.9,8.8-0.4c8.6,1.7,17.2,2.9,25.9,4.5c1.7,0.3,3.6,0.5,4.8-0.5
		c1.3-1.2,1.3-3.3,1.1-5.1c-0.4-4.2-1-8.4-1.8-12.6c-0.8-3.9-2.5-9.4-7.2-10.2c-1-0.2-2.2-0.2-2.9-1c-0.5-0.7-0.4-1.8,0-2.6
		c0.5-1.3,1.4-2.2,2.4-3.2c2.5-2.8,5.8-8.2,9.8-9.1c2.6-0.6,6,2.9,8.4,3.8c4,1.5,8.3,2.1,12.6,2.5c26.6,2.9,53.2,3.8,80,3.8
		c13.7,0,27.5-0.3,41.2-0.8c8.3-0.4,16.8-0.8,25.1-1.5c7.9-0.7,16.9-1.1,24.3-3.9c2.4-0.9,5.8-4.4,8.4-3.8c4.3,1,8.1,7.2,10.9,10.2
		c0.6,0.7,1.3,1.4,1.6,2.3c0.3,0.9,0.1,2.1-0.7,2.6c-0.4,0.4-1.1,0.4-1.7,0.4c-3,0.5-5.3,2.9-6.6,5.7c-2.5,5.4-2.2,11.9-3.2,17.7
		c-0.5,2.8,0.5,5.6,3.8,5.7c1.9,0.1,4.1-0.8,6-1.1c2.7-0.4,5.4-0.9,8.1-1.3c5.4-0.9,10.7-1.8,16.1-2.7c1.8-0.3,3.7-0.6,5.5-0.1
		c3.1,0.8,4.9,3.7,7.3,5.7c2.7,2.2,5.3,4.6,6.7,7.8C403.7,969.5,403.8,969.6,403.7,969.7z"
                              />
                              <path
                                class="st1"
                                d="M250.4,926.5L250.4,926.5h-0.8C249.9,926.5,250.2,926.5,250.4,926.5z"
                              />
                              <path
                                class="st2"
                                d="M249.8,984h0.4l0,0C250.1,984,249.9,984,249.8,984z"
                              />
                              <path
                                class="st1"
                                d="M137.3,933.5c-9.7-1.2-19.4-2.3-29.1-3.5c-9.6-1.1-19.1-2.2-28.7-3.1c-5.7-0.5-11.3-1.1-16.9-1.8
		c-0.4-0.1-5-0.7-4.9-0.4c0.3,3.2,1.2,6.4,1.8,9.6c0.5,2.3,1.1,4.8,2.3,6.8c1.3,2,3.3,3.4,5.5,4.2c2.3,0.9,4.8,1.3,7.3,1.5
		c1.7,0.2,3.4,0.3,5.1,0.4c5.1,0.4,10.1,1,15.2,1.9c2.1,0.4,4.1,0.7,6.2,1.1c14.8,2.5,29.7,5,44.5,7.5c0.6,0.1,1.3,0.2,1.9-0.3
		c0.5-0.4,0.4-1.3,0.4-1.9c-0.7-5.7-1.9-11.3-3.3-16.8c-0.4-1.3-0.7-2.5-1.6-3.4c-1.2-1.1-2.9-1.3-4.4-1.5
		C138.1,933.5,137.7,933.5,137.3,933.5z"
                              />
                              <path
                                class="st1"
                                d="M120.8,946.5c-0.1-1.9-0.3-3.9-0.5-5.7c-0.2-1.3-0.4-2.5-0.7-3.8c-0.2-1-0.3-2.2-1.2-2.8
		c-1-0.8-2.2-1.1-3.4-1.2c-3.3-0.3-6.6-0.4-9.9-0.8c-4.9-0.5-9.8-1.6-14.7-2.2c-2.4-0.4-5-1-7.5-0.9c0,0.5,0.4,1.3,0.4,1.9
		c0.2,0.7,0.4,1.3,0.5,2.1c0.9,3.8,1.3,7.5,1.5,11.4c0.1,1.9,1.3,1.6,2.8,1.8c1.1,0.1,2.2,0.3,3.3,0.4c2.2,0.3,4.3,0.6,6.4,1
		c6,1,12,1.9,18,3.1c0.8,0.2,1.7,0.4,2.5,0.3c1.5-0.1,2.4-0.8,2.4-2.4C120.8,947.9,120.8,947.2,120.8,946.5z"
                              />
                              <path
                                class="st1"
                                d="M125.9,951.6c-1.1-1.4-1.3-3.6-1.5-5.3c-0.3-2.5-0.2-5.1-0.7-7.6c-0.3-1-0.5-2.2-0.2-3.1
		c0.5-1.4,2-1.3,3.2-1.3c2.3,0.2,4.6,0.5,6.9,0.6c3.1,0.1,7.3-0.1,9.2,2.8c1.4,2,1.8,4.5,2.2,6.9c0.5,3.3,1,6.7,1,10.1
		c-0.1,1.5-0.9,1.6-2.2,1.1c-2.8-1.1-5.7-1.6-8.5-2c-1.3-0.2-2.7-0.4-4-0.4c-1.3,0-2.8,0-4-0.6C126.6,952.4,126.2,952,125.9,951.6z"
                              />
                              <path
                                class="st1"
                                d="M64.1,942c-1-1.3-1.2-3.2-1.3-4.7c-0.3-2.2-0.1-4.6-0.6-6.7c-0.2-0.9-0.4-1.9-0.1-2.8c0.4-1.3,1.7-1.2,2.9-1.1
		c2.1,0.2,4,0.4,6.1,0.5c2.8,0.1,6.4,0,8.2,2.5c1.3,1.7,1.5,3.9,1.9,6c0.4,2.9,0.8,5.9,0.8,8.9c-0.1,1.3-0.8,1.4-2,1
		c-2.4-0.9-4.9-1.4-7.5-1.7c-1.2-0.2-2.3-0.4-3.5-0.4c-1.2,0-2.5,0-3.6-0.6C64.7,942.6,64.4,942.3,64.1,942z"
                              />
                              <path
                                class="st1"
                                d="M362.9,934.1c9.7-1.2,19.4-2.3,29.1-3.5c9.6-1.1,19.1-2.2,28.7-3.1c5.7-0.5,11.3-1.1,16.9-1.8
		c0.4-0.1,5-0.7,4.9-0.4c-0.3,3.2-1.2,6.4-1.8,9.6c-0.5,2.3-1.1,4.8-2.3,6.8c-1.3,2-3.3,3.4-5.5,4.2c-2.3,0.9-4.8,1.3-7.3,1.5
		c-1.7,0.2-3.4,0.3-5.1,0.4c-5.1,0.4-10.1,1-15.2,1.9c-2.1,0.4-4.1,0.7-6.2,1.1c-14.8,2.5-29.7,5-44.5,7.5c-0.6,0.1-1.3,0.2-1.9-0.3
		c-0.5-0.4-0.4-1.3-0.4-1.9c0.7-5.7,1.9-11.3,3.3-16.8c0.4-1.3,0.7-2.5,1.6-3.4c1.2-1.1,2.9-1.3,4.4-1.5
		C362.1,934.2,362.6,934.1,362.9,934.1z"
                              />
                              <path
                                class="st1"
                                d="M379.4,947c0.1-1.9,0.3-3.9,0.5-5.7c0.2-1.3,0.4-2.5,0.7-3.8c0.2-1,0.3-2.2,1.2-2.8c1-0.8,2.2-1.1,3.4-1.2
		c3.3-0.3,6.6-0.4,9.9-0.8c4.9-0.5,9.8-1.6,14.7-2.2c2.4-0.4,5-1,7.5-0.9c0,0.5-0.4,1.3-0.4,1.9c-0.2,0.7-0.4,1.3-0.5,2.1
		c-0.9,3.8-1.3,7.5-1.5,11.4c-0.1,1.9-1.3,1.6-2.8,1.8c-1.1,0.1-2.2,0.3-3.3,0.4c-2.2,0.3-4.3,0.6-6.4,1c-6,1-12,1.9-18,3.1
		c-0.8,0.2-1.7,0.4-2.5,0.3c-1.5-0.1-2.4-0.8-2.4-2.4C379.3,948.4,379.3,947.7,379.4,947z"
                              />
                              <path
                                class="st1"
                                d="M374.3,952.1c1.1-1.4,1.3-3.6,1.5-5.3c0.3-2.5,0.2-5.1,0.7-7.6c0.3-1,0.5-2.2,0.2-3.1c-0.5-1.4-2-1.3-3.2-1.3
		c-2.3,0.2-4.6,0.5-6.9,0.6c-3.1,0.1-7.3-0.1-9.2,2.8c-1.4,2-1.8,4.5-2.2,6.9c-0.5,3.3-1,6.7-1,10.1c0.1,1.5,0.9,1.6,2.2,1.1
		c2.8-1.1,5.7-1.6,8.5-2c1.3-0.2,2.7-0.4,4-0.4c1.3,0,2.8,0,4-0.6C373.6,952.9,374,952.6,374.3,952.1z"
                              />
                              <path
                                class="st1"
                                d="M436.1,942.5c1-1.3,1.2-3.2,1.3-4.7c0.3-2.2,0.1-4.6,0.6-6.7c0.2-0.9,0.4-1.9,0.1-2.8
		c-0.4-1.3-1.7-1.2-2.9-1.1c-2.1,0.2-4,0.4-6.1,0.5c-2.8,0.1-6.4,0-8.2,2.5c-1.3,1.7-1.5,3.9-1.9,6c-0.4,2.9-0.8,5.9-0.8,8.9
		c0.1,1.3,0.8,1.4,2,1c2.4-0.9,4.9-1.4,7.5-1.7c1.2-0.2,2.3-0.4,3.5-0.4c1.2,0,2.5,0,3.6-0.6C435.4,943.2,435.8,942.9,436.1,942.5z"
                              />
                              <path
                                class="st1"
                                d="M477.8,956.6c0,5.7-3.6,11.1-7.9,14.7c-3.6,3-7.8,5.1-12.1,7c-45.4,20.2-97.9,24.4-146.9,27.8
		c-0.1,0-0.1,0-0.2,0c-52.9,3.7-106.1,2.7-158.8-2.9c-16.2-1.7-32.1-4-48.2-7.1c-22.2-4.4-44.4-9.7-65-19.5
		C31,973,22.1,966,22.1,956.6c0-7.8,4.3-10.7,10.7-6.6c7.5,4.8,15.5,8.8,24,11.9c17.1,6.6,35.2,10.1,53.1,13
		c52.4,8.6,105.5,12.7,158.6,11.6c21.8-0.4,43.6-1.8,65.3-3.9c24.1-2.4,48.2-5.8,72-10.6c22-4.4,44.1-10.3,62.7-23.2
		C474.8,944.7,477.8,951.1,477.8,956.6z"
                              />
                              <path
                                style={{ fill: this.fillColor("svg_LeftFrontDoor") }}
                                onClick={() => this.userClick("svg_LeftFrontDoor")}
                                class="st1"
                                d="M101.4,467.6v78.1c0,0,0,0.5,0,1.2c0,7.2-0.3,14.4-0.4,21.5c-0.1,3.6-0.1,7.3-0.2,10.9c0,1.8-0.1,3.6-0.1,5.5
		c0,2.2,0.3,4.8-2.6,4.9c-9,0.7-18,0.4-27,0.4c-11.8,0-23.7,0-35.5,0.1c-0.2,0-0.4,0-0.4-0.1c-0.1-0.1-0.1-0.3-0.1-0.4
		c-0.7-17.7-0.5-35.5-0.3-53.2c0.2-8.8,0.4-17.6,0.4-26.4c0.1-27,0.2-54,0.3-81.1c0-0.8,0-1.6,0-2.4c0-4.9,0-9.8,0-14.7
		c0-3.5-0.7-8.2,1.7-11c2-2.2,5.2-2.4,8.2-2.5c18.7-0.2,37.3-0.3,55.9,0c0.1,12,0.1,24,0.2,36L101.4,467.6z"
                              />
                              <path
                                style={{ fill: this.fillColor("svg_RightFrontDoor") }}
                                onClick={() => this.userClick("svg_RightFrontDoor")}
                                class="st1"
                                d="M465.3,467.6v78.1c0,0,0,0.5,0,1.2c0,7.2-0.3,14.4-0.4,21.5c-0.1,3.6-0.1,7.3-0.2,10.9c0,1.8-0.1,3.6-0.1,5.5
		c0,2.2,0.3,4.8-2.6,4.9c-9,0.7-18,0.4-27,0.4c-11.8,0-23.7,0-35.5,0.1c-0.2,0-0.4,0-0.4-0.1c-0.1-0.1-0.1-0.3-0.1-0.4
		c-0.7-17.7-0.5-35.5-0.3-53.2c0.2-8.8,0.4-17.6,0.4-26.4c0.1-27,0.2-54,0.3-81.1c0-0.8,0-1.6,0-2.4c0-4.9,0-9.8,0-14.7
		c0-3.5-0.7-8.2,1.7-11c2-2.2,5.2-2.4,8.2-2.5c18.7-0.2,37.3-0.3,55.9,0c0.1,12,0.1,24,0.2,36L465.3,467.6z"
                              />
                              <path
                                style={{ fill: this.fillColor("svg_LeftFrontFender") }}
                                onClick={() => this.userClick("svg_LeftFrontFender")}
                                class="st1"
                                d="M167,476.1c0,0.1-0.1,0.1-0.1,0.2c0.1-0.2-7.6-8.5-8.3-9.4c-2.7-3.3-5.4-6.6-7.9-10.1
		c-5.2-6.9-10.2-13.9-15.4-20.9c-5.5-7.3-11-14.5-16.6-21.7c-2.5-3.1-5-6.4-7.6-9.4c-2.6-3-4.9-5.9-8.7-7.5
		c-0.6-0.3-1.4-0.6-2.2-0.6c-3.2-0.7-6.6-0.7-9.9-0.7c-8.3,0-16.7,0.1-25,0.1c-6.9,0-17.4,0.5-21.6-6.1c-1.3-2.2-1.6-4.8-1.9-7.4
		c-0.6-6.6-1.2-13.1,0.1-19.6c2.8-14.1,17.1-20.1,24.9-31.2c7.7-11.1,12.1-24.7,12.1-38.3c0-3.9-0.4-7.6-1.1-11.4
		c-5-25.9-27.1-47.5-53.1-51.8c-3.6-0.6-7.8-1.3-9.4-4.6c-0.8-1.6-0.7-3.5-0.5-5.3c1.3-18.8,2.7-37.7,4.3-56.5
		c0.6-7.5,1.3-15.3,4.5-22.2c5.1-11.2,17-19.1,29.3-19.5c-1.3,13.5-2.6,27-3.9,40.5c-0.2,1.5-0.3,3.3,0.8,4.5c1,1.1,2.6,1.3,4,1.4
		c30.7,2.3,61.5,4.8,92.2,7.1c-2.2-0.2-9.6,32.8-10.5,36.1c-3.1,12.2-4.8,25-6.8,37.4c-4.1,26.7-7.2,53.6-9.2,80.5
		c-1.3,16.1-2.2,32.6,1.2,48.5c1.6,7.9,4.7,15.1,8.1,22.3c3.3,7.2,7.3,14.1,11.5,20.9c8.2,13.2,17.3,25.8,25,39.2
		c1.3,2.4,2.7,4.9,3.3,7.6C168.8,470.9,168.6,473.9,167,476.1z"
                              />
                              <path
                                class="st1"
                                d="M250,71.7c22.6-0.1,45.1,0.4,67.6,2.1c25.5,1.8,51,4.2,76.1,8.9c12.1,2.2,24.1,5,35.9,8.4
		c11.4,3.3,23.7,6.8,33.9,13c8.6,5.1,16.5,13.4,13.6,24.1c-0.4,1.4-1.1,2.9-2.4,3.6c-1.4,0.7-3.2,0.4-4.7-0.3
		c-3-1.3-5.5-3.4-8.1-5.3c-4.4-3.2-9.7-5-14.8-7c-5.7-2.2-11.6-4-17.4-5.7c-11.7-3.3-23.5-5.8-35.4-8.3c-22-4.4-44.2-7.5-66.5-9.5
		c-16.2-1.4-32.5-2.2-48.7-2.5c-9.7-0.2-19.5-0.2-29.3-0.4c-9.8,0.2-19.5,0.2-29.3,0.4c-16.2,0.4-32.5,1.1-48.7,2.5
		c-22.4,2-44.5,5-66.5,9.5c-11.8,2.4-23.7,4.9-35.4,8.3c-5.8,1.7-11.7,3.5-17.4,5.7c-5.1,1.9-10.4,3.8-14.8,7c-2.6,1.9-5,4-8.1,5.3
		c-1.5,0.6-3.2,1.1-4.7,0.3c-1.3-0.7-2-2.2-2.4-3.6c-3-10.8,4.9-19,13.6-24.1c10.3-6.1,22.5-9.6,33.9-13c11.8-3.4,23.8-6.2,35.9-8.4
		c25.1-4.7,50.6-7.1,76.1-8.9C204.9,72.2,227.4,71.7,250,71.7z"
                              />
                              <g>
                                <path
                                  class="st1"
                                  d="M250.4,97.2c58.8,0.5,117.9,4.5,174.8,19.7c5.3,1.4,11,3.3,13.6,8.1c-25.4-5.6-50.7-11.1-76.1-16.7
			c-1.6-0.4-4.2-0.5-5.6,0.7c-1.6,1.4-0.4,5.3-0.2,7.2c0.5,6.5,1.2,13,1.7,19.5c0.2,2.3,0.4,4.6,0.6,6.9c0.2,2.4,0.5,4.8,1.1,7.2
			c0.4,1.8,0.7,3.5,2.5,4.6c1.3,0.8,3.1,1.1,4.7,1.3c4.7,0,9.6,1.3,14.2,1.8c4.7,0.6,9.3,1.3,14,1.8c13.1,1.6,26.3,3.1,39.3,5.8
			c-0.6-0.2-1.8,0.4-2.5,0.4c-1.2,0.2-2.4,0.4-3.7,0.5c-2.3,0.3-4.8,0.5-7.1,0.8c-4.8,0.4-9.6,0.8-14.5,1.3c-9.6,0.9-19.3,1.5-29,2
			c-9.1,0.4-18,0.6-27.1,0.6c-4.2,0-8.5-0.2-12.7-0.2c-4.4,0.1-9.1-0.9-13.5-1.3c-18-1.5-36-2.5-53.9-2.9c-18-0.4-36.1-0.3-54,0.4
			c-9,0.5-18,0.9-26.9,1.5c-8.9,0.6-17.7,1.4-26.6,1.8c-13.9,0.5-27.8,0.5-41.7-0.1c-9.7-0.4-19.3-1.1-29-2
			c-4.8-0.4-9.7-0.8-14.5-1.3c-2.3-0.3-4.8-0.4-7.1-0.8c-1.3-0.2-2.4-0.4-3.7-0.5c-0.7-0.1-1.9-0.6-2.5-0.4
			c12.9-2.8,26.1-4.2,39.3-5.8c4.7-0.5,9.3-1.2,14-1.8c4.6-0.6,9.5-1.8,14.2-1.8c1.6-0.2,3.2-0.4,4.7-1.3c1.8-1.1,2.1-2.7,2.5-4.6
			c0.6-2.3,0.9-4.8,1.1-7.2c0.2-2.3,0.4-4.6,0.6-6.9c0.5-6.5,1.2-13,1.7-19.5c0.2-1.9,1.3-5.7-0.2-7.2c-1.3-1.3-3.9-1.1-5.6-0.7
			c-25.4,5.6-50.7,11.1-76.1,16.7c2.6-4.8,8.4-6.6,13.6-8.1c56.9-15.2,116.2-19.1,175.1-19.7c0,0,0,0,0.1,0
			C250.2,97.2,250.3,97.2,250.4,97.2z"
                                />
                                <path
                                  class="st1"
                                  d="M250.4,100.5c-0.2,0-0.3,0-0.4,0c-30.1-0.4-60.1,0.9-90,3.9c-3.9,0.4-8.1,1-10.7,3.9c-2,2.2-2.6,5.1-3.1,8
			c-1.2,6.8-1.9,13.6-2.2,20.6c-0.2,3.4-0.2,6.9-0.2,10.3c0,2.5-0.5,5.5,1.3,7.6c1,1.2,2.4,1.8,3.9,2.3c7.2,2.7,14.7,4.5,22.3,5.5
			c1.6,0.2,3.1,0.6,4.7,0.9c2.1,0.4,4.5,0.1,6.6,0.1c4.6,0,9.1,0,13.6,0.1c9.1,0,18.1,0.1,27.3,0.1c15.4,0.1,30.9,0.1,46.3,0.2
			c18,0.1,36.1,0.2,54.1-0.9c2.5-0.2,5.1-0.1,7.6-0.5c1.9-0.4,3.9-0.9,5.8-1.3c4.8-1,9.5-2.3,14.1-4c1.4-0.5,2.9-1.2,3.9-2.3
			c1.8-2.2,1.3-5,1.3-7.6c0-3.4,0-6.9-0.2-10.3c-0.4-6.9-1.1-13.7-2.2-20.6c-0.4-2.9-1.2-5.8-3.1-8c-2.6-2.9-6.8-3.5-10.7-3.9
			C310.3,101.4,280.3,100,250.4,100.5z"
                                />
                              </g>
                              <path
                                class="st1"
                                d="M370.2,111.5L370.2,111.5c-0.7-0.2-8.6-2.8-8.5-1.2c0.1,3,0.4,5.9,0.7,8.9c0.3,4.6,0.4,9.2,1,13.6
		c0.3,2.4,0.7,4.8,0.8,7.3c0.1,2.9,0.1,6,1.3,8.6c1.7,3.4,5.4,3,8.7,3c4.1,0,8.3,0.4,12.3,1.3c3.9,0.8,7.8,2,11.8,2.2
		c3.2,0.3,6.5,0.7,9.6,1c1,0.1,2.1,0.2,3.1,0.3c5.1,0.5,10.1,1.2,15.2,2.1c2.3,0.4,4.7,1.1,7,1.1c2.5,0,5-0.4,7.5-0.7
		c0.9-0.2-0.8-10.9-0.9-11.8c-0.5-6.2-1.2-12.5-2.6-18.5c-0.5-2.2-1.9-3.1-4.2-3.5c-4.9-0.8-9.8-2.2-14.6-3.2
		c-5.2-1.1-10.3-2.2-15.4-3.5c-7.3-1.8-14.4-3.6-21.7-4.7C377.5,113.3,373.8,112.6,370.2,111.5z"
                              />
                              <path
                                class="st1"
                                d="M351.4,152.5c-0.1,2.2-3.2,2.1-4.8,2c-10.8-0.3-21.5-0.1-32.2-0.1c-13.2,0-26.5,0-39.7,0c-0.1,0-0.1,0-0.2,0
		c-7.3,0-14.6,0-21.9,0c-7.4,0-14.7,0-22.1,0c-7,0-14,0-21,0c-6.3,0-12.5,0-18.8,0c-5.1,0-10.2,0-15.3,0c-3.6,0-7.1,0-10.7,0
		c-4.3,0-8.5,0-12.8,0c-0.6,0-1.3,0-1.9-0.3c-0.8-0.4-1.3-1.3-1.1-2.2s1.3-1.2,2.2-1.3c2.9-0.3,5.7,0,8.6,0h180.8
		c2.9,0,5.8-0.3,8.6,0C350.4,150.7,351.5,151.2,351.4,152.5z"
                              />
                              <path
                                class="st1"
                                d="M327.7,158.9c-0.1,2.2-2.4,2.1-3.7,2c-8.3-0.3-16.5-0.1-24.7-0.1c-10.1,0-20.3,0-30.4,0c-0.1,0-0.1,0-0.2,0
		c-5.6,0-11.2,0-16.8,0c-5.7,0-11.2,0-16.9,0c-5.4,0-10.7,0-16.1,0c-4.8,0-9.6,0-14.4,0c-3.9,0-7.8,0-11.8,0c-2.7,0-5.5,0-8.2,0
		c-3.3,0-6.6,0-9.9,0c-0.5,0-1,0-1.4-0.3c-0.6-0.4-1.1-1.3-0.8-2.2c0.3-0.9,1-1.2,1.6-1.3c2.2-0.3,4.4,0,6.6,0h138.5
		c2.2,0,4.5-0.3,6.6,0C326.9,157.1,327.8,157.6,327.7,158.9z"
                              />
                              <path
                                class="st1"
                                d="M351.4,146.2c-0.1,2.2-3.2,2.1-4.8,2c-10.8-0.3-21.5-0.1-32.2-0.1c-13.2,0-26.5,0-39.7,0c-0.1,0-0.1,0-0.2,0
		c-7.3,0-14.6,0-21.9,0c-7.4,0-14.7,0-22.1,0c-7,0-14,0-21,0c-6.3,0-12.5,0-18.8,0c-5.1,0-10.2,0-15.3,0c-3.6,0-7.1,0-10.7,0
		c-4.3,0-8.5,0-12.8,0c-0.6,0-1.3,0-1.9-0.3c-0.8-0.4-1.3-1.3-1.1-2.2s1.3-1.2,2.2-1.3c2.9-0.3,5.7,0,8.6,0h180.8
		c2.9,0,5.8-0.3,8.6,0C350.4,144.4,351.5,144.8,351.4,146.2z"
                              />
                              <path
                                class="st1"
                                d="M351.4,139.8c-0.1,2.2-3.2,2.1-4.8,2c-10.8-0.3-21.5-0.1-32.2-0.1c-13.2,0-26.5,0-39.7,0c-0.1,0-0.1,0-0.2,0
		c-7.3,0-14.6,0-21.9,0c-7.4,0-14.7,0-22.1,0c-7,0-14,0-21,0c-6.3,0-12.5,0-18.8,0c-5.1,0-10.2,0-15.3,0c-3.6,0-7.1,0-10.7,0
		c-4.3,0-8.5,0-12.8,0c-0.6,0-1.3,0-1.9-0.3c-0.8-0.4-1.3-1.3-1.1-2.2s1.3-1.2,2.2-1.3c2.9-0.3,5.7,0,8.6,0h180.8
		c2.9,0,5.8-0.3,8.6,0C350.4,138.1,351.5,138.4,351.4,139.8z"
                              />
                              <path
                                class="st1"
                                d="M351.4,133.4c-0.1,2.2-3.2,2.1-4.8,2c-10.8-0.3-21.5-0.1-32.2-0.1c-13.2,0-26.5,0-39.7,0c-0.1,0-0.1,0-0.2,0
		c-7.3,0-14.6,0-21.9,0c-7.4,0-14.7,0-22.1,0c-7,0-14,0-21,0c-6.3,0-12.5,0-18.8,0c-5.1,0-10.2,0-15.3,0c-3.6,0-7.1,0-10.7,0
		c-4.3,0-8.5,0-12.8,0c-0.6,0-1.3,0-1.9-0.3c-0.8-0.4-1.3-1.3-1.1-2.2s1.3-1.2,2.2-1.3c2.9-0.3,5.7,0,8.6,0h180.8
		c2.9,0,5.8-0.3,8.6,0C350.4,131.7,351.5,132.1,351.4,133.4z"
                              />
                              <path
                                class="st1"
                                d="M351.4,127c-0.1,2.2-3.2,2.1-4.8,2c-10.8-0.3-21.5-0.1-32.2-0.1c-13.2,0-26.5,0-39.7,0c-0.1,0-0.1,0-0.2,0
		c-7.3,0-14.6,0-21.9,0c-7.4,0-14.7,0-22.1,0c-7,0-14,0-21,0c-6.3,0-12.5,0-18.8,0c-5.1,0-10.2,0-15.3,0c-3.6,0-7.1,0-10.7,0
		c-4.3,0-8.5,0-12.8,0c-0.6,0-1.3,0-1.9-0.3c-0.8-0.4-1.3-1.3-1.1-2.2s1.3-1.2,2.2-1.3c2.9-0.3,5.7,0,8.6,0h180.8
		c2.9,0,5.8-0.3,8.6,0C350.4,125.3,351.5,125.7,351.4,127z"
                              />
                              <path
                                class="st1"
                                d="M351.4,120.7c-0.1,2.2-3.2,2.1-4.8,2c-10.8-0.3-21.5-0.1-32.2-0.1c-13.2,0-26.5,0-39.7,0c-0.1,0-0.1,0-0.2,0
		c-7.3,0-14.6,0-21.9,0c-7.4,0-14.7,0-22.1,0c-7,0-14,0-21,0c-6.3,0-12.5,0-18.8,0c-5.1,0-10.2,0-15.3,0c-3.6,0-7.1,0-10.7,0
		c-4.3,0-8.5,0-12.8,0c-0.6,0-1.3,0-1.9-0.3c-0.8-0.4-1.3-1.3-1.1-2.2c0.3-0.9,1.3-1.2,2.2-1.3c2.9-0.3,5.7,0,8.6,0h180.8
		c2.9,0,5.8-0.3,8.6,0C350.4,119,351.5,119.3,351.4,120.7z"
                              />
                              <path
                                class="st1"
                                d="M351.4,114.4c-0.1,2.2-3.2,2.1-4.8,2c-10.8-0.3-21.5-0.1-32.2-0.1c-13.2,0-26.5,0-39.7,0c-0.1,0-0.1,0-0.2,0
		c-7.3,0-14.6,0-21.9,0c-7.4,0-14.7,0-22.1,0c-7,0-14,0-21,0c-6.3,0-12.5,0-18.8,0c-5.1,0-10.2,0-15.3,0c-3.6,0-7.1,0-10.7,0
		c-4.3,0-8.5,0-12.8,0c-0.6,0-1.3,0-1.9-0.3c-0.8-0.4-1.3-1.3-1.1-2.2s1.3-1.2,2.2-1.3c2.9-0.3,5.7,0,8.6,0h180.8
		c2.9,0,5.8-0.3,8.6,0C350.4,112.6,351.5,113,351.4,114.4z"
                              />
                              <path
                                class="st1"
                                d="M343.7,108c-0.1,2.2-3,2.1-4.4,2c-10-0.3-19.8-0.1-29.8-0.1c-12.2,0-24.4,0-36.7,0c-0.1,0-0.1,0-0.2,0
		c-6.7,0-13.5,0-20.3,0c-6.8,0-13.6,0-20.4,0c-6.5,0-12.9,0-19.4,0c-5.7,0-11.6,0-17.3,0c-4.7,0-9.4,0-14.1,0c-3.3,0-6.6,0-9.9,0
		c-3.9,0-7.9,0-11.8,0c-0.6,0-1.3,0-1.8-0.3c-0.8-0.4-1.3-1.3-1-2.2s1.2-1.2,2-1.3c2.6-0.3,5.3,0,8,0h167c2.7,0,5.4-0.3,8,0
		C342.7,106.2,343.7,106.7,343.7,108z"
                              />
                              <path class="st1" d="M421,156.3" />
                              <path
                                class="st1"
                                d="M421,133.2c3.1,1.1,5.5,4.1,5.7,7.4c0.5,6.1-5.7,10.9-11.3,8.4C406.5,145.1,411.7,130.1,421,133.2z"
                              />
                              <path
                                class="st1"
                                d="M421.8,130.1c4.4,1.4,7.6,5.7,8,10.2c0.7,8.5-7.8,15.1-15.7,11.7C401.7,146.6,409.1,125.8,421.8,130.1z"
                              />
                              <path
                                class="st1"
                                d="M389,124.7c3.9,1.3,6.9,5.2,7.3,9.3c0.6,7.8-7.1,13.8-14.4,10.7C370.6,139.7,377.4,120.8,389,124.7z"
                              />
                              <path
                                class="st1"
                                d="M390.1,120.8c5.6,1.9,9.6,7.2,10.1,12.9c0.9,10.8-9.9,19.1-19.9,14.8C364.6,141.7,374,115.3,390.1,120.8z"
                              />
                              <path
                                class="st1"
                                d="M427.6,291c-0.1,1.9-0.2,3.8-0.1,5.7c0,0.3,0,0.4,0,0.7c0.4,9.8,3.4,19.4,8.4,27.7c5,8.5,12.4,16.2,21.2,20.8
		c5.1,2.7,10.7,4.3,16.3,5.7c2.5,0.6,5,1.3,7.6,1.8c2.2,0.4,4.7,0.5,6.4-1.1c1.8-1.7,1.3-4.9,1.3-7.2c-0.3-5.1-0.3-10.3-0.4-15.4
		c-0.1-5.3-0.2-10.6-0.2-15.9c-0.1-25.8-0.1-51.5-0.1-77.3c-5.3-0.9-9.9,0.6-15,1.7c-16,3.2-29.8,13.5-38,27.6
		c-3.9,7-6.5,14.8-7.4,22.8C427.7,289.5,427.6,290.2,427.6,291z"
                              />
                              <path class="st1" d="M349.2,181.7" />
                              <path class="st1" d="M355.6,195.8" />
                              <path
                                style={{ fill: this.fillColor("svg_Hood") }}
                                onClick={() => this.userClick("svg_Hood")}
                                class="st1"
                                d="M249.9,169.6c31.8,0,63.6,2,95.2,6c2,0.3,4.8,0.5,6.3,2.2c1.1,1.3,1.4,4,1.9,5.7c4.2,14.5,8,29.3,11,44.2
		c3,14.9,4.5,30,6.5,45.1c3.3,25.5,5.1,51.3,6.9,76.9c0.4,4.6,0.6,9.2,1.2,13.7c0.4,3.9-3.3,4-6.6,3.2
		c-33.2-8.3-67.2-13.2-101.4-14.6c-34.4-1.4-68.8,0.6-102.8,6.3c-13.5,2.2-27.6,4.4-40.7,8.5c-1.8,0.5-5,2.5-6-0.3
		c-0.3-0.7-0.2-1.5-0.2-2.3c0.4-4.8,0.6-9.6,1-14.4c2.3-34,4.8-68.3,10-102.1c1.8-12,4-24.1,6.8-36c1.4-6.1,3.1-12.2,4.8-18.2
		c0.9-3.1,1.8-6,2.8-9c0.7-2.1,1.2-5.9,2.9-7.5c0.8-0.7,1.9-0.9,2.9-1C184.6,171.8,217.3,169.7,249.9,169.6z"
                              />
                              <path
                                style={{ fill: this.fillColor("svg_Roof") }}
                                onClick={() => this.userClick("svg_Roof")}
                                class="st1"
                                d="M331.2,636.8c0,2.2,0,4.6,0,6.8c0,15.3,0,30.6,0,45.9c0,8.8,3.8,29.7-6.9,34.2c-8.9,3.8-21.7,3.5-31.3,4.4
		c-27.7,2.7-55.7,2.7-83.5,0.4c-7.6-0.6-15.3-0.5-23-1.7c-5.4-0.8-12.9-1.2-16-6.5c-1.3-2.3-1.4-5.2-1.5-8
		c-1.1-54.3-1.3-108.6-0.6-162.9c0.3-22.2,0.1-44.3,0.5-66.4c0.1-4.1,0.5-8.6,2.8-12.2c1.1-1.7,3.1-2.6,4.9-3.3
		c11.4-4,23.1-6.4,34.9-7.9c12.6-1.6,25.1-2.3,37.8-2.5h0.8c12.7,0.2,25.2,0.9,37.8,2.5c11.9,1.5,23.6,3.9,34.9,7.9
		c1.9,0.6,3.9,1.5,4.9,3.3c2.2,3.6,2.7,8.1,2.8,12.2C331.6,534.2,331.3,585.5,331.2,636.8z"
                              />
                              <path
                                style={{ fill: this.fillColor("svg_RightRoofFrame") }}
                                onClick={() => this.userClick("svg_RightRoofFrame")}
                                class="st1"
                                d="M331.8,632.7c0,2,0,4.2,0,6.2c0,13.9,0,27.9,0,41.8c0,8,0.3,27.1-0.6,31.2c-0.7,3.4-1.8,3.2-2.6,4
		c-2.3,2.5-4.6,2.5-7,0.3c-0.6-0.6-1.3-0.5-1.9-1.6c-0.4-0.7-1.1-1.1-1.3-5.9c-0.1-2.1-0.1-4.7-0.1-7.3c-0.1-49.5-0.1-99-0.1-148.4
		c0-20.2,0-40.3,0-60.5c0-3.8,0-7.9,0.2-11.1c0.1-1.6,0.3-2.4,0.4-3c1-3.7,1.9-5.8,2.9-7.2c1-1.5,2.1-2.1,3.2-2.3h0.1
		c1.1,0.2,2.1,0.8,3.2,2.3c1,1.4,2,3.5,2.9,7.2c0.2,0.6,0.3,1.4,0.4,3c0.2,3.3,0.2,7.4,0.2,11.1C331.9,539.2,331.8,586,331.8,632.7z
		"
                              />
                              <path
                                style={{ fill: this.fillColor("svg_LeftRoofFrame") }}
                                onClick={() => this.userClick("svg_LeftRoofFrame")}
                                class="st1"
                                d="M181.7,632.7c0,2,0,4.2,0,6.2c0,13.9,0,27.9,0,41.8c0,8,0.3,27.1-0.6,31.2c-0.7,3.4-1.8,3.2-2.6,4
		c-2.3,2.5-4.7,2.5-7,0.3c-0.6-0.6-1.3-0.5-1.9-1.6c-0.4-0.7-1.1-1.1-1.3-5.9c-0.1-2.1-0.1-4.7-0.1-7.3c-0.1-49.5-0.1-99-0.1-148.4
		c0-20.2,0-40.3,0-60.5c0-3.8,0-7.9,0.2-11.1c0.1-1.6,0.3-2.4,0.4-3c1-3.7,1.9-5.8,2.9-7.2c1-1.5,2.1-2.1,3.2-2.3h0.1
		c1.1,0.2,2.1,0.8,3.2,2.3c1,1.4,2,3.5,2.9,7.2c0.2,0.6,0.3,1.4,0.4,3c0.2,3.3,0.2,7.4,0.2,11.1C181.7,539.2,181.7,586,181.7,632.7z
		"
                              />
                              <path
                                class="st1"
                                d="M369.8,593.4c-6.6,0.3-13.3-0.2-19.9,0c-3.5,0.1-12.2-0.9-14.6,2.4c-1.2,1.7,0.9,2.6,2.1,3.1
		c1.3,0.5,2.9,0.5,4.3,0.4c2.5,0,5,0,7.6,0c19.5-0.1,39-0.2,58.5-0.3c9.8-0.1,19.5-0.1,29.3-0.2c9,0,17.8,0.4,26.7-0.9
		c0.4-0.1,1-0.2,1.3-0.5c0.4-0.4,0.4-1.1,0.2-1.6c-2.2-4.8-11.5-2.8-15.4-2.8c-4.8,0-9.5,0-14.3,0
		C413.6,593,391.7,592.6,369.8,593.4z"
                              />
                              <path
                                style={{ fill: this.fillColor("svg_RightBackDoor") }}
                                onClick={() => this.userClick("svg_RightBackDoor")}
                                class="st1"
                                d="M334.2,711.3c0,0.1,0.1,0.2,0.1,0.3c0.9,3.1,4.2,5.6,6.3,7.9c2.8,3.2,5.5,6.6,8.1,10
		c7.5,10,15.1,19.7,22.8,29.4c3.9,4.9,7.8,9.9,11.8,14.8c1.9,2.4,3.8,4.8,5.7,7.2c1.5,1.9,3.1,4.8,5.1,6.1c0.3,0.2,0.4,0.3,0.7,0.3
		c0.7,0,1-1,1-1.8c0.1-7.3-0.1-14.5-0.1-21.8c0-18,0-36.2,0-54.2c0-19.7,0-39.6,0-59.3c0-13,0-26.1,0-39.1c0-2.4,1-7.7-1.3-8.7
		c-0.4-0.2-1-0.2-1.5-0.2c-15.1-0.3-30.1-1.1-45.1-1.1c-3.4,0-6.7,0-10.1,0c-0.7,0-1.3,0-2,0.3c-0.9,0.4-1.4,1.3-1.7,2.3
		c-0.4,2.2,0.3,4.6,0.3,6.8c0,14.3,0,28.5,0,42.8c0,10.5,0,20.9,0,31.4c0,7.3-0.3,14.6-0.3,21.9
		C333.7,708.1,333.8,709.8,334.2,711.3z"
                              />
                              <path
                                class="st1"
                                d="M479.7,462.7c-1.5,38.5-3.6,77-4.5,115.5c-0.4,19.5-0.5,39-0.4,58.5c0.4,38.3,1.6,76.7,2.6,115
		c0.1,5,0.7,8.9-5,10c-9.4,1.9-18.3,5.9-26,11.8c-3.9,3-7.5,6.3-10.5,10.1c-2.9,3.5-6.9,14.9-13.3,12c-1.7-0.8-4.1-7.1,5.5-18.2
		c3.5-4,7.3-7.8,11.6-11c6.6-4.8,14.7-6.6,21.7-10.8c7.5-4.4,5.9-10.8,5.9-18.3c0-5.5,0-11,0-16.4c0-11,0-21.9,0-32.8
		c0-25.8,0.3-51.5,0-77.4c-0.2-17.2,1.2-34.6,0.6-51.9c-0.4-13.6-0.1-27.2-0.2-40.8c-0.1-12.7-0.2-25.4-0.4-38.1
		c0-25-1.2-49.8-1.3-74.8c0-4-1.8-4.8-4.6-7.1c-2.7-2.3-2.2-6.5-1.8-9.6c0.5-5.6,1.2-11,1.7-16.6c0.4-3.7,0-9.6,3.7-11.8
		c4.2-2.6,10.9-0.9,15.3,0.5c3.1,1,3.4,3.2,3.2,6.1c-0.4,7.9-0.8,15.7-1.1,23.6c-0.4,10.1-0.8,20.2-1.3,30.3
		C480.8,434.7,480.2,448.7,479.7,462.7z"
                              />
                              <path
                                style={{ fill: this.fillColor("svg_RightBackDoor") }}
                                onClick={() => this.userClick("svg_RightBackDoor")}
                                class="st1"
                                d="M397.9,733.9c0,14.3,0.3,28.5-0.1,42.7c-0.1,3.1-1.6,10.1,1.1,12.3c0.4,0.4,1.1,0.6,1.7,0.8
		c4.7,1.4,10.5,2.3,15-0.3c3.7-2.1,5.7-5.8,8-9.2c2.2-3.2,4.9-6.2,7.8-9c5.7-5.6,12.6-10.1,19.7-13.5c3.6-1.7,8.5-2.7,11.8-4.9
		c3.4-2.4,1.6-11.6,1.6-15.3c0-5.6,0.1-11.2,0.2-16.8c0.6-38.7,0.5-77.4,0.5-116c0-1.2-0.1-2.4-0.9-3.2c-0.7-0.6-1.8-0.6-2.7-0.6
		c-20.3,0.3-40.6,0.5-60.9,0.8c-0.8,0-1.7,0.1-2.2,0.6c-0.4,0.5-0.4,1.3-0.4,1.9c0,7.1,0,14.1,0,21.2
		C397.9,661.7,397.9,697.7,397.9,733.9z"
                              />
                              <path
                                style={{ fill: this.fillColor("svg_TrunkCover") }}
                                onClick={() => this.userClick("svg_TrunkCover")}
                                class="st1"
                                d="M250.8,924.9c8.9,0,17.8-0.1,26.6-0.4c13.5-0.4,26.9-1.1,40.4-2.2c6.7-0.5,13.7-0.8,20.4-1.9
		c10.7-1.7,15.1-14.7,17.6-23.7c3.9-14.2,6.5-28.7,8.3-43.4c0.9-7.4,1.7-14.6,2.3-22c0.6-7,2.2-14.1,1.3-21.1
		c0.3,2.4-64.4,6.3-70.3,6.6c-26.8,1.3-53.7,1.6-80.5,0.7c-11.3-0.4-22.7-1.8-34-1.8c-8.5-0.6-17-1.3-25.5-2.2
		c-4.3-0.4-8.6-0.9-12.9-1.3c-2.2-0.3-4.3-0.5-6.5-0.7c-0.8-0.1-4.1-1.2-4.8-0.7c-0.5,0.4-0.4,2.3-0.4,2.9c0,2.3,0.4,4.6,0.7,6.8
		c0.4,3.5,0.8,7.1,1,10.6c0.4,7.5,1.1,15.1,2.1,22.5c1.9,15,4.8,29.8,8.8,44.3c1.3,5,2.9,10.1,5.8,14.4c4.6,6.8,11.1,8.4,18.8,9.1
		C197,923.7,223.9,924.9,250.8,924.9z"
                              />
                              <path
                                class="st1"
                                d="M249.9,802.7c-28,0.1-55.7-0.5-83.5-5.1c-3.6-0.6-7.3-1.3-10.9-1.9c-3.4-0.6-7-1-10.3-2.1
		c-2.8-0.9-7.3-2.9-7.3-6.4c0-1,0.4-2,0.8-2.9c4.9-11.1,11-21.7,17.1-32.2c3.3-5.7,6.7-11.2,9.9-17.1c1.7-3.1,4-6.3,7.4-7.7
		c3.7-1.5,7.7-0.6,11.5,0.1c3.8,0.7,7.6,1.1,11.5,1.6c8.8,1.2,17.6,2.2,26.4,2.7c17.7,1.2,35.5,1.3,53.1,0.1
		c4.9-0.3,9.9-0.7,14.8-1.2c4.8-0.4,9.6-1,14.4-1.7c5.1-0.7,10.2-1.6,15.3-2.3c3.6-0.4,7.5-0.2,10.2,2.1c1.4,1.2,2.4,2.9,3.3,4.5
		c7.7,13.3,15.8,26.3,22.7,40c2.1,4.1,8.8,12.8,4.5,17.2c-1.9,1.9-4.6,2.6-7.2,3.1c-6,1.3-11.9,2.7-18,3.8
		c-26.7,4.8-53.9,5-81.1,5.1C253.1,802.7,251.4,802.7,249.9,802.7z"
                              />
                              <path
                                class="st1"
                                d="M428.3,836.3c0.3,1.3,0.5,2.7,0.9,4c3.7,14.7,12.1,27.6,25,35.8c4.8,3.1,10.2,5.5,15.8,7
		c1.8,0.4,18.2,3,18.2,1.9V767.2c-0.1-0.8-13,1.2-14.4,1.4c-5.1,1.1-10.1,2.8-14.6,5.2C436.6,785.4,424,811.7,428.3,836.3z"
                              />
                              <path
                                class="st1"
                                d="M250.4,926.5h-0.7l0,0C249.8,926.5,250,926.5,250.4,926.5L250.4,926.5z"
                              />
                              <path
                                class="st2"
                                d="M249.8,984c0.1,0,0.3,0,0.4,0H249.8L249.8,984z"
                              />
                              <path
                                class="st2"
                                d="M250.4,984L250.4,984h-0.8C249.9,984,250.2,984,250.4,984z"
                              />
                              <path
                                class="st1"
                                d="M147.5,433c0.4,0.8-16.2,12.2-17.6,13.2c-4,2.9-8.1,5.8-12,8.8c-3.9,2.9-7.6,5.7-11.5,8.5
		c-1.8,1.3-9.6,9-11.4,5.7c-2.7-4.9-5.4-9.8-8.1-14.7c-1.3-2.2,0-3.5,1.4-5.2c1.7-2,3.3-3.9,5-5.8c5.8-6.7,11.7-13.5,17.6-20.1
		c3-3.3,5.8-6.7,8.7-10.1c2.5-3,4.8-6.5,7.8-8.9c0.6-0.4,1.2-1,1.8-1.4C129.2,402.7,147.5,433,147.5,433z"
                              />
                              <path
                                style={{ fill: this.fillColor("svg_RightFrontDoor") }}
                                onClick={() => this.userClick("svg_RightFrontDoor")}
                                class="st1"
                                d="M334.2,493.4c0,4.3,0.3,8.6,0.3,12.7c0,25.8,0,51.6,0,77.4c0,2.1,0.2,4.6,2,5.7c1,0.6,2.3,0.6,3.5,0.6
		c7.9,0,15.8-0.4,23.7-0.4c10.7,0,21.3,0.2,32-0.1c1.3-36.3,1.6-72.5,1.2-108.8c-0.2-16.5-0.5-32.9-0.5-49.5
		c-0.3-10.4,0-20.9,0.1-31.3c-3,2.6-5.8,5.5-8.3,8.5c-10.6,12.7-18.8,27.5-29,40.5c-4.2,5.5-8.7,10.8-12.9,16.2
		c-4,5.3-8.8,10.9-10.6,17.3C334.5,485.8,334.2,489.6,334.2,493.4z"
                              />
                              <path
                                class="st1"
                                d="M394.7,420c0-0.9,0.1-1.8,0.1-2.8c0-4.4,0-8.8-0.1-13.2c0-0.3-0.1-0.7-0.4-0.7c-0.1,0-0.3,0.1-0.4,0.2
		c-0.6,0.5-1.1,1.2-1.5,1.9c-1.5,2.2-3.1,4.4-4.6,6.6c-0.4,0.6-0.9,1.3-1.2,2.1c-0.8,2.1,0.4,4.3,1.7,5.9c0.7,1.1,1.6,2.1,2.5,3.1
		c0.4,0.4,0.9,1,1.3,1.4c0.4,0.4,0.9,1.3,1.6,0.7c0.4-0.3,0.4-0.7,0.5-1.2C394.5,422.7,394.6,421.4,394.7,420z"
                              />
                              <path
                                style={{ fill: this.fillColor("svg_RightFrontFender") }}
                                onClick={() => this.userClick("svg_RightFrontFender")}
                                class="st1"
                                d="M332.9,476.1c0,0.1,0.1,0.1,0.1,0.2c-0.1-0.2,7.6-8.5,8.3-9.4c2.7-3.3,5.4-6.6,7.9-10.1
		c5.2-6.9,10.2-13.9,15.4-20.9c5.5-7.3,11-14.5,16.6-21.7c2.5-3.1,5-6.4,7.6-9.4c2.6-3,4.9-5.9,8.7-7.5c0.6-0.3,1.4-0.6,2.2-0.6
		c3.2-0.7,6.6-0.7,9.9-0.7c8.3,0,16.7,0.1,25,0.1c6.9,0,17.4,0.5,21.6-6.1c1.3-2.2,1.6-4.8,1.9-7.4c0.6-6.6,1.2-13.1-0.1-19.6
		c-2.8-14.1-17.1-20.1-24.9-31.2c-7.7-11.1-12.1-24.7-12.1-38.3c0-3.9,0.4-7.6,1.1-11.4c5-25.9,27.1-47.5,53.1-51.8
		c3.6-0.6,7.8-1.3,9.4-4.6c0.8-1.6,0.7-3.5,0.5-5.3c-1.3-18.8-2.7-37.7-4.3-56.5c-0.6-7.5-1.3-15.3-4.5-22.2
		c-5.1-11.2-17-19.1-29.3-19.5c1.3,13.5,2.6,27,3.9,40.5c0.2,1.5,0.3,3.3-0.8,4.5c-1,1.1-2.6,1.3-4,1.4c-30.7,2.3-61.5,4.8-92.2,7.1
		c2.2-0.2,9.6,32.8,10.5,36.1c3.1,12.2,4.8,25,6.8,37.4c4.1,26.7,7.2,53.6,9.2,80.5c1.3,16.1,2.2,32.6-1.2,48.5
		c-1.6,7.9-4.7,15.1-8.1,22.3c-3.3,7.2-7.3,14.1-11.5,20.9c-8.2,13.2-17.3,25.8-25,39.2c-1.3,2.4-2.7,4.9-3.3,7.6
		C331.1,470.9,331.3,473.9,332.9,476.1z"
                              />
                              <path
                                class="st1"
                                d="M352.4,433c-0.4,0.8,16.2,12.2,17.6,13.2c4,2.9,8.1,5.8,12,8.8c3.9,2.9,7.6,5.7,11.5,8.5
		c1.8,1.3,9.6,9,11.4,5.7c2.7-4.9,5.4-9.8,8.1-14.7c1.3-2.2,0-3.5-1.4-5.2c-1.7-2-3.3-3.9-5-5.8c-5.8-6.7-11.7-13.5-17.6-20.1
		c-3-3.3-5.8-6.7-8.7-10.1c-2.5-3-4.8-6.5-7.8-8.9c-0.6-0.4-1.2-1-1.8-1.4C370.7,402.7,352.4,433,352.4,433z"
                              />
                              <g class={`${this.addClassName("svg_Hood")}`}>
                                <circle
                                  style={{ fill: this.fillColor("svg_Hood") }}
                                  onClick={() => this.userClick("svg_Hood")}
                                  class="st1"
                                  cx="250"
                                  cy="268.8"
                                  r="13.8"
                                />
                                <g>
                                  <path d="M253.6,275.3h-7.1V274h2.8v-9.8l-2.9,0.9v-1.4l4.3-1.3V274h2.8V275.3z" />
                                </g>
                              </g>
                              <g class={`${this.addClassName("svg_LeftFrontDoor")} path_wrapper`}>
                              <circle
                                style={{ fill: this.fillColor("svg_LeftFrontDoor") }}
                                onClick={() => this.userClick("svg_LeftFrontDoor")}
                                class="st3"
                                cx="74.7"
                                cy="494.1"
                                r="13.8"
                              />
                                <path
                                  d="M74.7,508.3c-7.8,0-14.2-6.4-14.2-14.2c0-7.8,6.4-14.2,14.2-14.2c7.8,0,14.2,6.4,14.2,14.2
			C88.9,501.9,82.5,508.3,74.7,508.3z M74.7,480.8c-7.3,0-13.3,6-13.3,13.3c0,7.3,6,13.3,13.3,13.3c7.3,0,13.3-6,13.3-13.3
			C88,486.7,82,480.8,74.7,480.8z"
                                />
                                <g>
                                  <path
                                    d="M71.1,499.9v-1.6c0.9,0.7,1.8,1,2.9,1c0.9,0,1.6-0.2,2.1-0.7s0.8-1,0.8-1.8c0-1.6-1.2-2.5-3.5-2.5h-1v-1.2h1
				c2.1,0,3.1-0.8,3.1-2.3c0-1.4-0.8-2.1-2.4-2.1c-0.9,0-1.7,0.3-2.5,0.9v-1.4c0.8-0.5,1.8-0.7,2.9-0.7c1.1,0,1.9,0.3,2.5,0.8
				c0.6,0.6,1,1.3,1,2.2c0,1.7-0.8,2.7-2.5,3.2v0c0.9,0.1,1.6,0.4,2.2,1c0.5,0.5,0.8,1.2,0.8,2c0,1.1-0.4,2-1.2,2.7
				c-0.8,0.7-1.9,1-3.2,1C72.7,500.6,71.8,500.4,71.1,499.9z"
                                  />
                                </g>
                              </g>
                              <g class={`${this.addClassName("svg_LeftFrontFender")}`}>
                                <circle
                                  style={{ fill: this.fillColor("svg_LeftFrontFender") }}
                                  onClick={() => this.userClick("svg_LeftFrontFender")}
                                  class="st1"
                                  cx="92.3"
                                  cy="226.1"
                                  r="13.8"
                                />
                                <g>
                                  <path
                                    d="M96,232.5h-7.6v-1.3l3.7-3.7c0.9-0.9,1.6-1.7,2-2.3c0.4-0.6,0.6-1.3,0.6-2c0-0.7-0.2-1.3-0.6-1.7c-0.4-0.4-1-0.6-1.8-0.6
				c-1.1,0-2.2,0.5-3.2,1.4v-1.5c1-0.8,2.1-1.1,3.4-1.1c1.1,0,2,0.3,2.6,0.9c0.6,0.6,1,1.4,1,2.4c0,0.8-0.2,1.6-0.7,2.4
				c-0.4,0.8-1.2,1.7-2.4,2.9l-2.9,2.9v0H96V232.5z"
                                  />
                                </g>
                              </g>
                              <g class={`${this.addClassName("svg_LeftBackDoor")}`}>
                                <g>
                                  <circle
                                    style={{ fill: this.fillColor("svg_LeftBackDoor") }}
                                    onClick={() => this.userClick("svg_LeftBackDoor")}
                                    class="st3"
                                    cx="74.7"
                                    cy="677.3"
                                    r="13.8"
                                  />
                                  <path
                                    d="M74.7,691.5c-7.8,0-14.2-6.4-14.2-14.2s6.4-14.2,14.2-14.2c7.8,0,14.2,6.4,14.2,14.2S82.5,691.5,74.7,691.5z M74.7,664
				c-7.3,0-13.3,6-13.3,13.3c0,7.3,6,13.3,13.3,13.3c7.3,0,13.3-6,13.3-13.3C88,669.9,82,664,74.7,664z"
                                  />
                                </g>
                                <g>
                                  <path
                                    d="M79.2,680.2h-1.6v3.3h-1.4v-3.3h-5.9v-0.9l5.6-8.3h1.7v8.1h1.6V680.2z M76.1,679.1v-5.4c0-0.4,0-0.8,0-1.3h0
				c-0.1,0.2-0.2,0.5-0.5,1l-3.9,5.8H76.1z"
                                  />
                                </g>
                              </g>
                              <g class={`${this.addClassName("svg_LeftBackFender")}`}>
                                <g>
                                  <circle
                                    style={{ fill: this.fillColor("svg_LeftBackFender") }}
                                    onClick={() => this.userClick("svg_LeftBackFender")}
                                    class="st3"
                                    cx="99.8"
                                    cy="867.7"
                                    r="13.8"
                                  />
                                  <path
                                    d="M99.8,881.9c-7.8,0-14.2-6.4-14.2-14.2s6.4-14.2,14.2-14.2c7.8,0,14.2,6.4,14.2,14.2S107.7,881.9,99.8,881.9z
				 M99.8,854.4c-7.3,0-13.3,6-13.3,13.3c0,7.3,6,13.3,13.3,13.3c7.3,0,13.3-6,13.3-13.3C113.1,860.3,107.2,854.4,99.8,854.4z"
                                  />
                                </g>
                                <g>
                                  <path
                                    d="M96.3,873.5V872c0.9,0.6,1.7,0.8,2.6,0.8s1.6-0.3,2.1-0.8c0.5-0.5,0.8-1.2,0.8-2c0-0.8-0.3-1.5-0.8-1.9
				c-0.6-0.5-1.3-0.7-2.4-0.7c-0.4,0-1,0-2,0.1v-6.3h6.1v1.3h-4.7v3.7c0.4,0,0.7,0,1.1,0c1.3,0,2.4,0.3,3.1,1
				c0.7,0.7,1.1,1.6,1.1,2.8c0,1.2-0.4,2.2-1.2,2.9c-0.8,0.7-1.9,1.1-3.3,1.1C97.8,874.1,96.9,873.9,96.3,873.5z"
                                  />
                                </g>
                              </g>
                              <g class={`${this.addClassName("svg_TrunkCover")}`}>
                                <g>
                                  <circle
                                    style={{ fill: this.fillColor("svg_TrunkCover") }}
                                    onClick={() => this.userClick("svg_TrunkCover")}
                                    class="st3"
                                    cx="250.4"
                                    cy="867.7"
                                    r="13.8"
                                  />
                                  <path
                                    d="M250.4,881.9c-7.8,0-14.2-6.4-14.2-14.2s6.4-14.2,14.2-14.2c7.8,0,14.2,6.4,14.2,14.2S258.2,881.9,250.4,881.9z
				 M250.4,854.4c-7.3,0-13.3,6-13.3,13.3c0,7.3,6,13.3,13.3,13.3c7.3,0,13.3-6,13.3-13.3C263.7,860.3,257.7,854.4,250.4,854.4z"
                                  />
                                </g>
                                <g>
                                  <path
                                    d="M253.6,861.5v1.4c-0.6-0.3-1.3-0.5-2.1-0.5c-1.1,0-2,0.5-2.7,1.5c-0.7,1-1,2.3-1,4h0c0.6-1.2,1.5-1.8,2.9-1.8
				c1.1,0,2,0.4,2.6,1.1c0.6,0.7,1,1.6,1,2.8c0,1.2-0.4,2.2-1.1,3s-1.7,1.2-2.8,1.2c-1.3,0-2.3-0.5-3-1.5c-0.7-1-1.1-2.4-1.1-4.2
				c0-2.2,0.5-4,1.4-5.3c0.9-1.3,2.2-2,3.7-2C252.4,861.2,253.1,861.3,253.6,861.5z M250.5,867.3c-0.7,0-1.3,0.3-1.8,0.8
				c-0.5,0.5-0.7,1.1-0.7,1.8c0,0.9,0.2,1.6,0.7,2.2c0.5,0.6,1.1,0.9,1.8,0.9c0.7,0,1.3-0.3,1.8-0.8c0.4-0.5,0.7-1.2,0.7-2
				c0-0.9-0.2-1.6-0.6-2.1C251.9,867.6,251.3,867.3,250.5,867.3z"
                                  />
                                </g>
                              </g>
                              <circle
                                style={{ fill: this.fillColor("svg_RightBackFender") }}
                                onClick={() => this.userClick("svg_RightBackFender")}
                                class="st3"
                                cx="400.2"
                                cy="867.7"
                                r="13.8"
                              />
                              <g class={`${this.addClassName("svg_RightBackFender")}`}>
                                <path class={`${this.addClassName("svg_RightBackFender")} path_wrapper`}
                                  d="M400.2,881.9c-7.8,0-14.2-6.4-14.2-14.2s6.4-14.2,14.2-14.2s14.2,6.4,14.2,14.2S408,881.9,400.2,881.9z M400.2,854.4
			c-7.3,0-13.3,6-13.3,13.3c0,7.3,6,13.3,13.3,13.3c7.3,0,13.3-6,13.3-13.3C413.5,860.3,407.5,854.4,400.2,854.4z"
                                />
                                <path d="M404.2,861.8l-5,12.1h-1.5l4.7-11.3h-6.3v-1.3h8.1V861.8z" class={`${this.addClassName("svg_RightBackFender")} path_wrapper`} />
                              </g>
                              <g class={`${this.addClassName("svg_RightBackDoor")}`}>
                                <g>
                                  <circle
                                    style={{ fill: this.fillColor("svg_RightBackDoor") }}
                                    onClick={() => this.userClick("svg_RightBackDoor")}
                                    class="st3"
                                    cx="431.3"
                                    cy="677.3"
                                    r="13.8"
                                  />
                                  <path
                                    d="M431.3,691.5c-7.8,0-14.2-6.4-14.2-14.2s6.4-14.2,14.2-14.2c7.8,0,14.2,6.4,14.2,14.2S439.1,691.5,431.3,691.5z
				 M431.3,664c-7.3,0-13.3,6-13.3,13.3c0,7.3,6,13.3,13.3,13.3c7.3,0,13.3-6,13.3-13.3C444.6,669.9,438.6,664,431.3,664z"
                                  />
                                </g>
                                <g>
                                  <path
                                    d="M430,677L430,677c-1.5-0.7-2.3-1.8-2.3-3.1c0-0.9,0.3-1.6,1-2.2c0.7-0.6,1.6-0.9,2.7-0.9c1,0,1.8,0.3,2.4,0.8
				c0.6,0.5,0.9,1.2,0.9,2.1c0,1.4-0.8,2.5-2.3,3.2v0c1.8,0.7,2.8,1.8,2.8,3.4c0,1-0.4,1.9-1.1,2.5s-1.8,0.9-3.1,0.9
				c-1.1,0-2-0.3-2.7-0.9s-1-1.4-1-2.4C427.3,678.9,428.2,677.7,430,677z M431.2,677.7c-1.6,0.6-2.4,1.6-2.4,2.8
				c0,0.6,0.2,1.1,0.7,1.5c0.5,0.4,1.1,0.6,1.8,0.6c0.7,0,1.3-0.2,1.8-0.6c0.5-0.4,0.7-0.9,0.7-1.5
				C433.8,679.2,432.9,678.3,431.2,677.7z M433.4,673.9c0-0.6-0.2-1-0.5-1.4c-0.4-0.3-0.9-0.5-1.5-0.5c-0.6,0-1.1,0.2-1.5,0.5
				c-0.4,0.3-0.6,0.8-0.6,1.3c0,1.1,0.7,1.9,2,2.5C432.7,675.7,433.4,674.9,433.4,673.9z"
                                  />
                                </g>
                              </g>
                              <g class={`${this.addClassName("svg_RightFrontDoor")}`}>
                                <g>
                                  <circle
                                    style={{ fill: this.fillColor("svg_RightFrontDoor") }}
                                    onClick={() => this.userClick("svg_RightFrontDoor")}
                                    class="st3"
                                    cx="431.3"
                                    cy="501.7"
                                    r="13.8"
                                  />
                                  <path
                                    d="M431.3,515.9c-7.8,0-14.2-6.4-14.2-14.2c0-7.8,6.4-14.2,14.2-14.2c7.8,0,14.2,6.4,14.2,14.2
				C445.5,509.5,439.1,515.9,431.3,515.9z M431.3,488.4c-7.3,0-13.3,6-13.3,13.3c0,7.3,6,13.3,13.3,13.3c7.3,0,13.3-6,13.3-13.3
				C444.6,494.3,438.6,488.4,431.3,488.4z"
                                  />
                                </g>
                                <g>
                                  <path
                                    d="M428,507.7v-1.4c0.7,0.4,1.4,0.6,2.2,0.6c1.1,0,2-0.5,2.7-1.4c0.6-0.9,1-2.2,1-3.9c0,0,0,0,0,0c-0.5,1.1-1.5,1.6-2.8,1.6
				c-1.1,0-2-0.4-2.6-1.1c-0.7-0.7-1-1.7-1-2.8c0-1.2,0.4-2.2,1.1-3c0.8-0.8,1.7-1.2,2.9-1.2c1.2,0,2.2,0.5,2.9,1.5
				c0.7,1,1,2.4,1,4.3c0,2.3-0.4,4.1-1.3,5.4c-0.9,1.3-2.2,1.9-3.8,1.9C429.3,508.2,428.6,508,428,507.7z M431.2,496.4
				c-0.7,0-1.3,0.3-1.7,0.8c-0.5,0.5-0.7,1.2-0.7,2c0,0.9,0.2,1.6,0.7,2.1c0.5,0.5,1.1,0.8,1.8,0.8c0.7,0,1.3-0.2,1.7-0.7
				c0.5-0.5,0.7-1,0.7-1.7c0-1-0.2-1.7-0.7-2.3C432.6,496.7,432,496.4,431.2,496.4z"
                                  />
                                </g>
                              </g>
                              <g class={`${this.addClassName("svg_RightFrontFender")}`}>
                                <g>
                                  <circle
                                    style={{
                                      fill: this.fillColor("svg_RightFrontFender"),
                                    }}
                                    onClick={() => this.userClick("svg_RightFrontFender")}
                                    class="st3"
                                    cx="407.7"
                                    cy="226.1"
                                    r="13.8"
                                  />
                                  <path
                                    d="M407.7,240.3c-7.8,0-14.2-6.4-14.2-14.2c0-7.8,6.4-14.2,14.2-14.2s14.2,6.4,14.2,14.2
				C421.9,233.9,415.5,240.3,407.7,240.3z M407.7,212.8c-7.3,0-13.3,6-13.3,13.3c0,7.3,6,13.3,13.3,13.3c7.3,0,13.3-6,13.3-13.3
				C421,218.8,415,212.8,407.7,212.8z"
                                  />
                                </g>
                                <g>
                                  <path d="M406.3,232.4h-7.1v-1.3h2.8v-9.8l-2.9,0.9v-1.4l4.3-1.3v11.6h2.8V232.4z" />
                                  <path
                                    d="M412.1,232.6c-1.2,0-2.2-0.5-2.9-1.6c-0.7-1.1-1-2.6-1-4.6c0-2.2,0.4-3.9,1.1-5c0.7-1.1,1.8-1.7,3.2-1.7
				c2.6,0,3.9,2.1,3.9,6.4c0,2.1-0.4,3.8-1.1,4.9S413.4,232.6,412.1,232.6z M412.3,220.9c-1.8,0-2.7,1.8-2.7,5.5
				c0,3.4,0.9,5.1,2.6,5.1c1.7,0,2.6-1.7,2.6-5.2C414.8,222.6,414,220.9,412.3,220.9z"
                                  />
                                </g>
                              </g>
                              <g class={`${this.addClassName("svg_Roof")}`}>
                                <g>
                                  <circle
                                    style={{ fill: this.fillColor("svg_Roof") }}
                                    onClick={() => this.userClick("svg_Roof")}
                                    class="st3"
                                    cx="246.4"
                                    cy="677.3"
                                    r="13.8"
                                  />
                                  <path
                                    d="M246.4,691.5c-7.8,0-14.2-6.4-14.2-14.2s6.4-14.2,14.2-14.2c7.8,0,14.2,6.4,14.2,14.2S254.2,691.5,246.4,691.5z
				 M246.4,664c-7.3,0-13.3,6-13.3,13.3c0,7.3,6,13.3,13.3,13.3c7.3,0,13.3-6,13.3-13.3C259.7,669.9,253.7,664,246.4,664z"
                                  />
                                </g>
                                <g>
                                  <path d="M245.2,683.7h-7.1v-1.3h2.8v-9.8l-2.9,0.9v-1.4l4.3-1.3v11.6h2.8V683.7z" />
                                  <path d="M254.8,683.7h-7.1v-1.3h2.8v-9.8l-2.9,0.9v-1.4l4.3-1.3v11.6h2.8V683.7z" />
                                </g>
                              </g>
                              <g  class={`${this.addClassName("svg_LeftRoofFrame")}`}>
                                <g>
                                  <circle
                                    style={{ fill: this.fillColor("svg_LeftRoofFrame") }}
                                    onClick={() => this.userClick("svg_LeftRoofFrame")}
                                    class="st3"
                                    cx="198.4"
                                    cy="589"
                                    r="13.8"
                                  />
                                  <path
                                    d="M198.4,603.2c-7.8,0-14.2-6.4-14.2-14.2c0-7.8,6.4-14.2,14.2-14.2c7.8,0,14.2,6.4,14.2,14.2
				C212.7,596.8,206.3,603.2,198.4,603.2z M198.4,575.7c-7.3,0-13.3,6-13.3,13.3c0,7.3,6,13.3,13.3,13.3c7.3,0,13.3-6,13.3-13.3
				C211.8,581.6,205.8,575.7,198.4,575.7z"
                                  />
                                </g>
                                <g>
                                  <path d="M197.3,595.4h-7.1v-1.3h2.8v-9.8l-2.9,0.9v-1.4l4.3-1.3v11.6h2.8V595.4z" />
                                  <path
                                    d="M206.7,595.4h-7.6v-1.3l3.7-3.7c0.9-0.9,1.6-1.7,2-2.3c0.4-0.6,0.6-1.3,0.6-2c0-0.7-0.2-1.3-0.6-1.7
				c-0.4-0.4-1-0.6-1.8-0.6c-1.1,0-2.2,0.5-3.2,1.4v-1.5c1-0.8,2.1-1.1,3.4-1.1c1.1,0,2,0.3,2.6,0.9c0.6,0.6,1,1.4,1,2.4
				c0,0.8-0.2,1.6-0.7,2.4c-0.4,0.8-1.2,1.7-2.4,2.9l-2.9,2.9v0h5.8V595.4z"
                                  />
                                </g>
                              </g>
                              <g  class={`${this.addClassName("svg_RightRoofFrame")}`}>
                                <g>
                                  <circle
                                    style={{ fill: this.fillColor("svg_RightRoofFrame") }}
                                    onClick={() => this.userClick("svg_RightRoofFrame")}
                                    class="st3"
                                    cx="301.4"
                                    cy="589"
                                    r="13.7"
                                  />
                                  <path
                                    d="M301.4,603.2c-7.8,0-14.2-6.4-14.2-14.2s6.4-14.2,14.2-14.2c7.8,0,14.2,6.4,14.2,14.2S309.2,603.2,301.4,603.2z
				 M301.4,575.7c-7.3,0-13.3,6-13.3,13.3c0,7.3,6,13.3,13.3,13.3c7.3,0,13.3-6,13.3-13.3C314.7,581.7,308.7,575.7,301.4,575.7z"
                                  />
                                </g>
                                <g>
                                  <path d="M300.2,595.5H293v-1.3h2.9v-10l-3,0.9v-1.4l4.4-1.4v11.8h2.9V595.5z" />
                                  <path
                                    d="M302.4,595v-1.6c0.9,0.7,1.9,1,3,1c0.9,0,1.6-0.2,2.1-0.7c0.5-0.4,0.8-1.1,0.8-1.8c0-1.7-1.2-2.5-3.6-2.5h-1.1v-1.2h1
				c2.1,0,3.2-0.8,3.2-2.4c0-1.5-0.8-2.2-2.4-2.2c-0.9,0-1.8,0.3-2.6,0.9v-1.4c0.8-0.5,1.8-0.7,2.9-0.7c1.1,0,1.9,0.3,2.6,0.9
				c0.6,0.6,1,1.3,1,2.2c0,1.7-0.9,2.8-2.6,3.3v0c0.9,0.1,1.7,0.4,2.2,1c0.5,0.6,0.8,1.3,0.8,2.1c0,1.2-0.4,2.1-1.2,2.8
				c-0.8,0.7-1.9,1.1-3.3,1.1C304.1,595.7,303.2,595.4,302.4,595z"
                                  />
                                </g>
                              </g>
                            </g>
                          </svg>

                          {
          isLightBoxOpen &&
          <>
          <Lightbox
            className="photoapp_lightbox_main"
            reactModalStyle={{
              overlay: { zIndex: 100000000 },
              content: {},
            }}
            toolbarButtons={toolbarButtons}
            mainSrc={
             `${clickedPartName}?${Date.now()}`
            }

            onCloseRequest={() =>
              this.setState({
                isLightBoxOpen: false,
              })
            }

            onImageLoadError={(...events) => { console.log(events) }}

            imageLoadErrorMessage={
              <img
                style={{ height: "100%", width: "100%" }}
                src={dashboardErrorImg}
              />
            }
          />
          </>
        }
      </>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(PreDamage13SVG);
